<template>
  <!-- height: calc(100vh - 56px) is put for removing body and wrapper height, without this some of the tabs were collapsing -->
  <!-- added 44.667px for the navbar in total height -->
  <div class="telemed row" style="height: calc(100vh - 100.667px)" :class="device.platform == 'iOS' ? 'ios' : ''">
    <div class="col-md-12" style="height: 100%;" :class="{ 'show-ripple': showRipple, 'disable-input': disableInput }">
      <tabs ref="mainTab" @TabChange="onTabChange" position="bottom" centered type="neutral" tab-nav-wrapper-classes="card-header-nav icon" tab-nav-classes="icon-white" tab-content-classes="tab-content-padding tab-no-space " v-model="activeTab" style="height: 100%;overflow:hidden;">

        <!-- Chat tab -->
        <tab-pane label="chat-message" v-if="chatMode">
          <template slot="label">
            <i class="fas fa-comment-alt" />
          </template>

          <div v-if="appointment" style="position: relative; height:0em; z-index: 1;">
            <div>
              <card>
                <div class="row">
                  <div class="col-1">
                    <i class="fas fa-user pr-3" style="line-height: 35px; font-size: 1.5em"></i>
                  </div>
                  <div class="col-11" style="display: grid;align-items: center;">
                    <span>
                      {{ `${appointment.patient.firstName} ${appointment.patient.lastName},` }}
                      <small>{{ getAgeYears(appointment.patient.dob) }}</small><span class="badge badge-success" v-if="onGoingCall" style="float:right;"><i class="fas fa-video" style="margin-right: 0.5em;"></i> {{ $t("message.ongoing call") }}</span>
                    </span>
                  </div>
                </div>
              </card>
            </div>
          </div>

          <beautiful-chat :participants="participants" :titleImageUrl="titleImageUrl" :onMessageWasSent="onMessageWasSent" :messageList="messageList" :newMessagesCount="newMessagesCount" :isOpen="true" :close="closeChat" :open="openChat" :showEmoji="true" :showFile="true" :showTypingIndicator="showTypingIndicator" :colors="colors" :alwaysScrollToBottom="true" :messageStyling="messageStyling" :uploading="CHAT_FILE_UPLOADING" @onType="handleOnType" :showHeader="false" @download-file="viewFile">

            <!-- User avatar-->
            <template v-slot:user-avatar="{ message }">
              <div style="border-radius:50%; font-size: 15px; line-height:25px; text-align:center;background: white; width: 25px !important; height: 25px !important; min-width: 30px;min-height: 30px;margin: 5px; font-weight:bold" v-if="message.author != 'me' && (message.data && message.type != 'system') && message.author != 'carenation-bot'">
                <img :src="messageAvatar(message.author)" alt="" style="border-radius: 50%; width: 100%; height: 100%;">
              </div>
              <div style="border-radius:50%; font-size: 15px; line-height:25px; text-align:center; width: 25px !important; height: 25px !important; min-width: 30px;min-height: 30px;margin: 5px; font-weight:bold; overflow: hidden;" v-if="message.author != 'me' && (message.data && message.type != 'system') && message.author == 'carenation-bot'">
                <img :src="carenationBotImage" alt="" style="padding: 5px; width: 100%; height: 100%; background-color: gray;">
              </div>
            </template>

            <!-- Message body-->
            <template v-slot:text-message-body="{ message }">
              {{ message.data.text }}<br />
              <small v-if="message.data.meta" style="font-size: 60%; font-weight: 200; font-style: italic;">
                {{ message.data.meta }}
              </small>
            </template>

            <!-- System message-->
            <template v-slot:system-message-body="{ message }">
              <span class="fa-stack fa-2x" v-if="message.meta && message.meta.icon && message.meta.icon != 'fas fa-video-slash' && message.meta.icon != 'fas fa-phone-alt'" style="font-size: 0.5em; margin-inline-end: 1em;">
                <i class="fas fa-video fa-stack-2x"></i>
                <i :class="message.meta.icon + ' fa-stack-1x fa-inverse'" style="transform: rotate(45deg); top:0.5em;" v-if="message.meta.icon == 'fas fa-arrow-up' || message.meta.icon == 'fas fa-arrow-down'"> </i>
                <i :class="message.meta.icon + ' fa-stack-1x fa-inverse'" v-else style="left: 10%;"> </i>
              </span>
              <span v-if="message.meta && message.meta.icon && message.meta.icon == 'fas fa-video-slash'" style="font-size: 0.5em; margin-inline-end: 1em;">
                <i :class="message.meta.icon" style="font-size: 1.8em;"> </i>
              </span>
              <span v-if="message.meta && message.meta.icon && message.meta.icon == 'fas fa-phone-alt'" style="font-size: 0.5em; margin-inline-end: 1em;">
                <i :class="message.meta.icon" style="font-size: 1.8em;"> </i>
              </span>
              <span v-if="!message.meta.icon" style="font-size: 0.5em; margin-inline-end: 1em;">
                <i class="fas fa-info-circle" style="font-size: 1.8em;"></i>
              </span><span>{{ message.text }}</span>
              <div v-if="message.meta.time" style="font-size: 0.8em; font-style: italic; padding-top: 0.4em;">{{ message.meta.time }}</div>
              <div v-if="message.meta && !message.meta.time" style="font-size: 0.8em; font-style: italic; padding-top: 0.4em;">{{ message.meta }}</div>
            </template>

            <!-- File message body-->
            <template v-slot:file-message-body="{ message }">
              <div v-if="message.file.type == 'application/pdf' || message.file.type == 'prescription'">
                <div class="sc-message--file-icon" style="display: inline;">
                  <i v-if="message.file.type == 'application/pdf'" class="fas fa-file-pdf" style="font-size: 3em; cursor: pointer;" @click="viewFile(message.file)"></i>
                  <i v-if="message.file.type == 'prescription'" class="fas fa-file-prescription" style="font-size: 3em; cursor: pointer;" @click="viewFile(message.file)"></i>
                </div>
                <div class="sc-message--file-name" style="display: inline; padding-left: 5px; padding-right: 5px;">
                  <a v-if="message.file.type == 'application/pdf'" @click.prevent="viewFile(message.file)" :href="message.file.url ? message.file.url : '#'" target="_blank">{{ message.file.name || '' }}</a>
                  <a v-if="message.file.type == 'prescription'" @click.prevent="viewFile(message.file)" :href="message.file.url ? message.file.url : '#'" target="_blank">{{ message.file.name || '' }}</a>
                </div>
                <div v-if="message.text" class="sc-message--file-text" style="padding: 1em 0 0 0">
                  {{ message.text }}
                  <span v-if="message.meta">
                    <small style="font-size: 60%; font-weight: 200; font-style: italic;">
                      {{ message.meta }}
                    </small>
                  </span>
                </div>
                <div v-else class="sc-message--file-text-meta" style="padding: 1em 0 0 0">
                  <span v-if="message.meta">
                    <small style="font-size: 60%; font-weight: 200; font-style: italic;">
                      {{ message.meta }}
                    </small>
                  </span>
                </div>
              </div>

              <div v-if="message.file.type.includes('image/') || message.file.type.includes('video/')">
                <div class="sc-message--file-icon">
                  <dynamic-image v-if="message.file.type.includes('image/')" :file-id="message.file.url" class="sc-image" @click.native="showPreview(message.file)" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0;" />
                  <dynamic-video v-if="message.file.type.includes('video/')" :file-id="message.file.url" class="sc-video" controlsList="nodownload" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0;" :options="{ controls: true }" />
                </div>
                <div class="sc-message--file-name" style="display: flex; padding: 1em; background-color: #00000036 !important; border-bottom-left-radius: 3px; border-bottom-right-radius: 3px;">
                  <a v-if="message.file.type.includes('image/')" style="flex: 2; display: grid; justify-items: left; align-items: center;" @click.prevent="showPreview(message.file)" :href="message.file.url ? message.file.url : '#'" target="_blank">{{ message.file.name || '' }}</a>
                  <a v-else style="flex: 2; display: grid; justify-items: left; align-items: center;" @click.prevent="" :href="message.file.url ? message.file.url : '#'" target="_blank">{{ message.file.name || '' }}</a>
                  <i class="fas fa-arrow-down" style="cursor: pointer; font-size: 3em; margin-left: auto;" @click="viewFile(message.file)"></i>
                </div>
                <div v-if="message.text" class="sc-message--file-text">
                  {{ message.text }}
                  <p v-if="message.meta" style="text-align: right; font-size: xx-small; margin-bottom: -1em;">
                    {{ message.meta }}
                  </p>
                </div>
                <div v-else class="sc-message--file-text">
                  <p v-if="message.meta" style="text-align: right; font-size: xx-small; margin-bottom: -1em;">
                    {{ message.meta }}
                  </p>
                </div>
              </div>
            </template>

            <!-- Send file preview -->
            <template v-slot:file-preview="{ file }">
              <i v-if="file.type == 'application/pdf'" class="fas fa-file-pdf" id="preview-pdf" />
              <img v-if="file.type.includes('image/')" class="rounded mx-auto d-block" id="preview-img" :src="getFileSrc(file)" />
              <video v-if="file.type.includes('video/')" class="rounded mx-auto d-block" id="preview-video" :src="getFileSrc(file)"></video>
            </template>

          </beautiful-chat>

          <div class="col-12 chat-ended" v-if="appointment && appointment.latestStatus && ['Closed', 'Completed', 'Postponed'].includes(appointment.latestStatus)">
            <h4 style="margin-bottom: 0px;">{{ $t("message.Chat session has ended") }}</h4>
          </div>
          <div v-if="showPreviewModal" style="position: absolute;
              top: 0px;
              left: 0px;
              width: 100%;
              background: rgba(128, 128, 128, 0.83);
              z-index: 1;
              height: calc(100vh - 56px);
              display: flex;
              justify-content: center;
              align-items: center;">

            <dynamic-image v-if="previewFile.type.includes('image/')" :file-id="previewFile.url" class="sc-image" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0; max-width:100%; max-height: 100vh;" />

            <div style="position: absolute; top: 1em; inset-inline-end: 1em; background: #00000070; padding: 1em; border-radius: 3px;">
              <i class="fas fa-arrow-down" style="cursor: pointer; color: white; font-size: 2em; margin-right: 1em;" @click="viewFile(previewFile)"></i>
              <i class="fas fa-times" @click="showPreviewModal = false" style="cursor: pointer; color: white; font-size: 2em;"></i>
            </div>

          </div>
        </tab-pane>

        <!-- VC -->
        <tab-pane label="video-call" :class="{ 'video-call-tab': draggable }" v-if="!inpersonConsultation">
          <template slot="label">
            <i class="fa fa-video" style="position: relative;">
              <div class="la-ball-scale-multiple la-dark video-active" style="
                  position: absolute;
                  top: -6px;
                  left: -5px;
                  color: var(--color-primary);
                  display: none;
                ">
                <div></div>
                <div></div>
                <div></div>
              </div>
            </i>
          </template>

          <VueDragResize :parentLimitation="true" :parentW="parentWidth" :parentH="parentHeight" v-if="showVideoCall" :axis="'both'" :preventActiveBehavior="preventActiveBehavior" :isDraggable="draggable" :isResizable="false" :z="1030" :w="'auto'" :h="'auto'" :y="floatingVideoPositionY + 20" :x="floatingVideoPositionX" :contentClass="contentClass">
            <div :class="vmaatuClass">
              <vmaatu :query="simpleMeetingsQuery" v-if="settings &&
                user.endpoint &&
                user.endpoint.videoConfEPType == 'VMAATU_RTC' &&
                simpleMeetingsQuery
                " ref="vmaatu" :waiting-msg="waitingMsg" :hide-controls="hideVmaatuControls"></vmaatu>
              <webex-teams v-if="simpleMeetingsQuery &&
                ((user.endpoint &&
                  user.endpoint.videoConfEPType == 'WEBEXTEAMS_GUEST' || user.endpoint.videoConfEPType == 'SPARK_EMBEDDED') ||
                  (appointment.consultationType == 'telemed-direct' &&
                    settings.directTelemedicine.videoConfType ==
                    'WEBEX_TEAMS'))
                " :query="simpleMeetingsQuery" ref="webex-teams" :hide-controls="hideVmaatuControls"></webex-teams>

              <n-button type='danger' size="md" class="end-button" @click.native="endCall()" v-if="chatMode && showVideo">
                <i class="fas fa-phone-slash"></i>
                {{ $t("message.End") }}
              </n-button>

            </div>
          </VueDragResize>

          <call-notification-discussion :style="activeTab != 'video-call' ? 'display: none;' : ''" v-if="callNotification" :caller="caller" :callType="callType" @call-declined="callNotification = false" @call-accepted="callNotification = false" @call-missed="callNotification = false" @call-cancelled="callNotification = false">
          </call-notification-discussion>

          <div class="floating-ptz" v-if="REMOTE_EP_PTZ_ENABLED && IS_DOCTOR && (!chatMode || showVideo)">
            <div class="circleMenu">
              <nav>
                <ul class="outer">
                  <li>
                    <span class="mainBtn" @click="ptzExecute('reset', 'None')" @contextmenu="false">
                      <i class="fa fa-sync-alt" style="margin-left: 31%;margin-top: 31%;color: #637BEF;font-size: 1.3em;"></i>
                    </span>
                    <ul class="inner" @contextmenu="false">
                      <li @mousedown="ptzExecute('pan', 'Left')" @mouseup="ptzExecute('pan', 'Stop')" @touchstart="ptzExecute('pan', 'Left')" @touchend="ptzExecute('pan', 'Stop')" @contextmenu="false"><i class="fa fa-chevron-left fa-2x"></i></li>
                      <li @mousedown="ptzExecute('tilt', 'Up')" @mouseup="ptzExecute('tilt', 'Stop')" @touchstart="ptzExecute('tilt', 'Up')" @touchend="ptzExecute('tilt', 'Stop')" @contextmenu="false"><i class="fa fa-chevron-up fa-2x"></i></li>
                      <li @mousedown="ptzExecute('pan', 'Right')" @mouseup="ptzExecute('pan', 'Stop')" @touchstart="ptzExecute('pan', 'Right')" @touchend="ptzExecute('pan', 'Stop')" @contextmenu="false"><i class="fa fa-chevron-right fa-2x"></i></li>
                      <li @mousedown="ptzExecute('tilt', 'Down')" @mouseup="ptzExecute('tilt', 'Stop')" @touchstart="ptzExecute('tilt', 'Down')" @touchend="ptzExecute('tilt', 'Stop')" @contextmenu="false"><i class="fa fa-chevron-down fa-2x"></i></li>
                    </ul>
                  </li>
                </ul>
              </nav>
            </div>
          </div>

          <ul class="zoom-buttons" @contextmenu="false" v-if="REMOTE_EP_PTZ_ENABLED && IS_DOCTOR && (!chatMode || showVideo)">
            <li @mousedown="ptzExecute('zoom', 'In')" @mouseup="ptzExecute('zoom', 'Stop')" @touchstart="ptzExecute('zoom', 'In')" @touchend="ptzExecute('zoom', 'Stop')" @contextmenu="false">
              <span class="fa-stack fa-lg">
                <i class="fa fa-circle fa-stack-2x"></i>
                <i class="fa fa-search-plus fa-stack-1x fa-inverse zoom-in" style="position: absolute;left: 21%;"></i>
              </span>
            </li>
            <li @mousedown="ptzExecute('zoom', 'Out')" @mouseup="ptzExecute('zoom', 'Stop')" @touchstart="ptzExecute('zoom', 'Out')" @touchend="ptzExecute('zoom', 'Stop')" @contextmenu="false">
              <span class="fa-stack fa-lg">
                <i class="fa fa-circle fa-stack-2x"></i>
                <i class="fa fa-search-minus fa-stack-1x fa-inverse zoom-out" style="position: absolute;left: 21%;"></i>
              </span>
            </li>
          </ul>

          <n-button type="primary" icon round simple size="lg" v-if="!showVideoCall && activeTab == 'video-call' && !mountedLoader && !callNotification && appointment.latestStatus == 'Assigned'" @click.native="makeVideoCall()" class="make-video-call-button">
            <i class="fa fa-video" />
          </n-button>

          <p v-if="!showVideoCall && activeTab == 'video-call' && !mountedLoader && !callNotification && appointment.latestStatus == 'Assigned'" class="start-video-text">{{ $t("message.Ring again") }}</p>

        </tab-pane>

        <!-- Patient History -->
        <tab-pane label="patient-history">
          <template slot="label">
            <i class="fa fa-user" />
          </template>

          <!-- wait for patient to be added -->
          <div v-if="IS_NURSE && !patient" class="row pt-4 text-center" style="height: 100%;overflow: scroll;padding-top: 2em;">
            <div class="col-md-6 col-lg-4">
              <div style="font-weight: bold">{{ $t("message.Patient not added yet") }}</div>
              <doctor-patient-svg style="height: 15em; width: 100%; margin-top: 20em"></doctor-patient-svg>
            </div>
          </div>

          <!-- Add Patient details for Discussion appointments -->
          <div class="col-12 mt-2" v-if="IS_DOCTOR && appointment.appointmentType == 'Discussion'">
            <div class="col-12">
              <div :noFooterLine="true" :class="{ 'h-100 mb-0': createPatientBtnFixed }" :footerClasses="{ 'create-button-fixed': createPatientBtnFixed, 'pt-0': true }" headerClasses="pt-0">
                <div slot="header">
                  <div class="row">
                    <div class="col-10">
                      <h6 slot="header" class="card-title" v-if="!patient">
                        <span v-if="IS_DOCTOR">{{ $t("message.Enter patient details to proceed with prescription") }} </span>
                        <span v-if="IS_NURSE">{{ $t("message.Enter patient details to receive prescription") }} </span>
                      </h6>
                      <!-- <h4 v-if="appointment.patient.firstName" slot="header" class="card-title">
                        <span>{{ $t("message.Patient Details") }} </span>
                      </h4> -->
                      <small v-if="!PATIENT_SELECTED && !patient">
                        <i>{{ $t("message.Search or create new patient") }}</i>
                      </small>
                    </div>
                    <!-- <div class="col-2 text-right pt-2" v-if="PATIENT_SELECTED || appointment.patient.firstName">
                      <i class="fa fa-times-circle fa-2x text-muted" style="font-weight: 100" @click="resetPatientSelection()"></i>
                    </div> -->
                  </div>
                </div>

                <!-- Patient search -->
                <div class="row h-100" v-if="!PATIENT_SELECTED && !patient">
                  <div class="col-12 h-100">
                    <cool-select class="custom-input" :placeholder="$t('message.Start typing Name / EMR ID / Mobile No')" :items=[] ref="select" disable-filtering-by-search :resetSearchOnBlur="false" @search="searchPatients" item-text="firstName" item-value="name" :search-text.sync="patientSearchText">
                      <template slot="no-data">
                        <div v-show="patientSearchText && patientSearchText.length > 2 && patients.length < 1">{{ $t("message.No patients found") }}</div>
                      </template>
                    </cool-select>
                    <div style="align-items: center" class="patient-selection pl-3 pr-1" v-if="patientSearchText && patients.length > 0">
                      <div class="row" v-for="patient in patients" :key="patient._id" @click="selectPatient(patient)">
                        <div class="pr-1 col-11 autocomplete-result">
                          <div class="row">
                            <div class="col-2 pl-0 pr-0">
                              <profile-image :file-id="patient.profileImage" image-class="avatar border-gray" :image-style="'border-radius: 50%;width:50px;height: 50px; background-size: cover;'" v-if="patient.profileImage">
                              </profile-image>
                              <i class="fa fa-user-injured text-center" v-if="!patient.profileImage" style="background: #888;padding: 10px;border-radius: 50%;color: #fff;border: 4px solid;width: 50px;height: 50px;font-size: large;"></i>
                            </div>
                            <div class="col-10">
                              <h6 class="item-name">
                                {{ patient.firstName }} {{ patient.lastName }}
                              </h6>
                              <div class="row">
                                <div class="col-3 pr-0">{{ getGender(patient.gender) }}</div>
                                <div class="col-8 pr-0">{{ getAge(patient.dob) }}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="pl-0 col-1" style="color: #616060;display: flex;justify-content: center;align-items: center;">
                          <i class="now-ui-icons arrows-1_minimal-right"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Patient details-->
                <!-- <div class="row" v-if="PATIENT_SELECTED || appointment.patient.firstName">
                  <div class="col-3 pl-1 pr-0">
                    <profile-image :file-id="patientProfileImage" image-class="avatar border-gray" :image-style="'border-radius: 50%;width:5em;height: 5em; background-size: cover; margin: auto'" v-if="patientProfileImage">
                    </profile-image>
                    <i class="fa fa-user-injured text-center" v-if="!patientProfileImage" style="background: #888;padding: 10px;border-radius: 50%;color: #fff;border: 4px solid;width: 80px;height: 80px;font-size: 3em;"></i>
                  </div>
                  <div class="col-9 pl-1">
                    <div class="row">
                      <div class="col-md-1 col-3 text-center">
                        <span>
                          <i class="fa fa-user"></i>
                        </span>
                      </div>
                      <div class="col-md-8 col-9 pl-0">
                        <span>{{ appointment.patient.firstName }}
                          {{ appointment.patient.lastName }}</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-1 col-3 text-center">
                        <span>
                          <i class="fa fa-info-circle"></i>
                        </span>
                      </div>
                      <div class="col-md-10 col-9 pl-0">
                        <span>{{appointment.patient.patientId}}</span>
                      </div>
                    </div>
                    <div class="row" v-if="appointment.patient.mobileNumber">
                      <div class="col-md-1 col-3 text-center">
                        <span>
                          <i class="fa fa-mobile"></i>
                        </span>
                      </div>
                      <div class="col-md-8 col-9 pl-0">
                        <span>{{appointment.patient.mobileNumber}}</span>
                      </div>
                    </div>
                    <div class="row" v-if="appointment.patient.email">
                      <div class="col-md-1 col-3 text-center">
                        <span>
                          <i class="fa fa-envelope"></i>
                        </span>
                      </div>
                      <div class="col-md-8 col-9 pl-0">
                        <span>{{appointment.patient.email}}</span>
                      </div>
                    </div>
                    <div class="row" v-if="appointment.patient.history">
                      <div class="col-md-1 col-3 text-center">
                        <span>
                          <i class="fas fa-history"></i>
                        </span>
                      </div>
                      <div class="col-md-8 col-9 pl-0">
                        <span>{{appointment.patient.history}}</span>
                      </div>
                    </div>
                  </div>
                </div> -->

                <div slot="footer" class="col-12 text-center" v-if="!PATIENT_SELECTED && !patient">
                  <h6 style="margin-bottom: 15px;">{{ $t("message.OR") }}</h6>
                  <n-button type="primary" round @click.native="initiatePatientCreation()">
                    <h6 class="m-0">{{ $t("message.Create new patient") }}</h6>
                  </n-button>
                </div>
              </div>
            </div>
          </div>

          <tabs v-if="patient && patient.firstName" type="primary" centered class="patient-history-tabs" tab-nav-wrapper-classes="p-0" style="padding-top:1em;">
            <!-- Bio -->
            <tab-pane label="Bio" v-if="patient.firstName">
              <template slot="label">
                <span class="pl-2">{{ $t("message.Bio") }}</span>
              </template>
              <div class="col-12">
                <div class="row">
                  <div class="col-12 text-center">
                    <img :src="require('@/assets/img/proAvatar.png')" style="width: 100px; height: 100px; border-radius: 50%" v-if="!patient.profileImage" />
                    <profile-image :file-id="patient.profileImage" image-style="width: 100px; height: 100px; border-radius: 50%; margin: auto;" v-if="patient.profileImage">
                    </profile-image>
                  </div>
                  <div class="col-12 text-center mt-3">
                    {{ patient.patientId }}
                    <h6 class="mt-2">
                      {{ patient.firstName }} {{ patient.lastName }}
                    </h6>
                    {{ getAge(patient.dob) }}
                    <br />
                    <div style="font-size: 30px">
                      <span v-if="patient.gender == 'male'" style="color: rgb(33, 150, 243)">
                        <i class="fa fa-mars"></i>
                      </span>
                      <span v-if="patient.gender == 'female'" style="color: rgb(235, 63, 157)">
                        <i class="fa fa-venus"></i>
                      </span>
                      <span v-if="patient.gender == 'others'" style="color: rgb(33, 243, 208)">
                        <i class="fa fa-transgender-alt"></i>
                      </span>
                    </div>
                  </div>

                  <div class="col-12 mt-5" v-if="patientIdFile">
                    <card>
                      <div slot="header">
                        <h6>{{ $t("message.Patient ID") }}</h6>
                      </div>
                      <div class="col-12 text-center">
                        <dynamic-image :file-id="patientIdFile.fileId" image-style="max-height: 245px">
                        </dynamic-image>
                      </div>
                    </card>
                  </div>
                </div>
              </div>
              <n-button v-if="(PATIENT_SELECTED || patient) && IS_DOCTOR" type="primary" round size="lg" @click.native="
                resetPatientSelection()
                " id="main-create-discussion-button" style="
                  top: auto;
                  bottom: 0px;
                  left: 50%;
                  transform: translateX(-50%);
                  position: absolute;
                  width: 15em;
                ">
                <i class="fas fa-sync-alt pr-2"></i>
                {{ $t("message.Change Patient") }}
              </n-button>
            </tab-pane>

            <!-- Vitals history -->
            <tab-pane label="Vitals">
              <template slot="label">
                <span @click="getVitalHistory()" class="pl-2">{{ $t("message.Vitals") }}</span>
              </template>
              <div v-if="deviceProfile.length > 0" class="col-12" style="height: 100%; overflow: scroll;">
                <div class="row">
                  <div class="col-md-6 col-lg-4" v-for="(device, index) in deviceProfile" :key="device.identifier" :id="device.identifier">
                    <vital-card :deviceforcard="device" :vitals="device.vitals" :vital-index="index" ref="vitalComponents" v-if="device.communication.communicationMethod != 'NOTIFY'" :error-messages="errorMessages" :allowManualEntry="false" :allowRetrieval="false" :hideVitalHistory="false" :historic-vitals="historicVitals" :disableInputs="true" :shareVitals="shareVitals" :shareButton="false" :vital-group="false"></vital-card>

                    <span v-if="vitalDevice && vitalDevice.vitalsGroup && IS_NURSE" style="width:100%">
                      <div v-for="group in  vitalDevice.vitalsGroup" :key="group.identifier" style="padding:0px;width:100%">
                        <vital-card :deviceforcard="device" :vitals="group.vitals" :vital-index="index" ref="vitalComponents" v-if="device.communication.communicationMethod != 'NOTIFY' && device.vitalsGroup" :error-messages="errorMessages" :allowManualEntry="false" :allowRetrieval="false" :hideVitalHistory="false" :historic-vitals="historicVitals" :disableInputs="true" :shareVitals="shareVitals" :shareButton="false" :vital-group="false"></vital-card>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
              <div v-else class="no-device-profile" style="
                    text-align: center;">
                <h5 style="margin-top: 10vh;">{{ $t("message.No vitals available") }}</h5>
                <vitals-not-configured-svg style="height: 39vh; width: 63vw;"></vitals-not-configured-svg>
              </div>
            </tab-pane>

            <!-- Files history -->
            <tab-pane label="Files">
              <template slot="label">
                <span class="pl-2">{{ $t("message.Files") }}</span>
              </template>
              <div class="col-12" style="overflow-y: scroll;overflow-x: hidden;height: 100%;">
                <div>
                  <div class="col-12 mt-5 text-center" v-if="!historicFiles || historicFiles.length < 1">
                    {{ $t("message.No files for the patient") }}
                  </div>
                  <div class="col-12 file-list" v-for="file in historicFiles" :key="file.fileId">
                    <div>
                      <div class="col-12">
                        <div class="row">
                          <div class="col-2 col-md-2 col-lg-2">
                            <div v-if="file.type.indexOf('image') > -1">
                              <dynamic-image :file-id="file.fileId" image-style="min-height: 20px; width: 100%" @click.native="viewFile(file)">
                              </dynamic-image>
                            </div>
                            <div v-else-if="file.type.indexOf('pdf') > -1">
                              <i class="fa fa-file-pdf" style="font-size: 2em; color: #208fdc"></i>
                            </div>
                            <div v-else-if="file.type.indexOf('video') > -1">
                              <i class="fa fa-file-video" style="font-size: 2em; color: #208fdc"></i>
                            </div>
                            <div v-else-if="file.type.indexOf('audio') > -1">
                              <i class="fa fa-file-audio" style="font-size: 2em; color: #208fdc"></i>
                            </div>
                            <div v-else>
                              <i class="fa fa-file" style="font-size: 2em; color: #208fdc"></i>
                            </div>
                          </div>
                          <div class="col-8 col-md-8 col-lg-8" @click="viewFile(file)">
                            <p class="card-heading">{{ file.name }}</p>
                            <p class="card-heading file-date">
                              {{ getFormattedDate(file.created) }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </tab-pane>

            <!-- Prescription history -->
            <tab-pane label="Notes">
              <template slot="label">
                <span class="pl-2">{{ $t("message.Notes") }}</span>
              </template>
              <div class="col-12" style="height: 100%; overflow: scroll;">
                <div v-if="historicPrescriptions">
                  <div class="row">
                    <div class="col-12" v-if="!selectedPrescription">
                      <!-- List for extra small devices -->
                      <div class="row d-block d-md-block">
                        <div class="col-12 prescription-list" v-for="prescription in historicPrescriptions" :key="prescription._id">
                          <div @click="viewPrescription(prescription)">
                            <div class="col-12">
                              <div class="row">
                                <div class="col-2 col-md-1">
                                  <i class="el-icon-tickets prescription-icon"></i>
                                </div>
                                <div class="col-10 col-md-11">
                                  <p class="card-heading reason">
                                    {{ prescription.reason }}
                                  </p>
                                  <p class="card-heading mb-0">
                                    {{ $t("message.Dr") }} .
                                    {{ prescription.provider.firstName }}
                                    {{ prescription.provider.lastName }}
                                  </p>
                                  <p class="card-heading">
                                    {{
                                      getFormattedDate(prescription.created)
                                    }}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div v-if="historicPrescriptions.length < 1" class="col-12 text-center">
                          <i class="fa fa-info-circle"></i>
                          {{ $t("message.No Prescriptions available") }}
                        </div>
                      </div>
                    </div>

                    <div v-if="selectedPrescription">
                      <n-button type="primary" round @click.native="selectedPrescription = null" icon style="position: fixed;left:1em; top:10em; z-index: 1">
                        <i class="now-ui-icons arrows-1_minimal-left"></i>
                      </n-button>
                      <card>
                        <view-prescription :prescription_="selectedPrescription.prescriptions" v-if="selectedPrescription" :appointment="selectedPrescription"></view-prescription>
                      </card>
                    </div>
                  </div>
                </div>
              </div>
            </tab-pane>

            <!-- patient laborders -->
            <tab-pane label="Laborders">
              <template slot="label">
                <span class="pl-2">{{ $t("message.Lab Tests") }}</span>
              </template>
              <div class="col-12" style="height: 100%; overflow: scroll;">
                <div v-if="patientLaborders">
                  <div class="row align-items-center">
                    <div class="col-12" v-if="!selectedLaborder">
                      <div class="row d-block d-md-block">
                        <div class="col-12 prescription-list" v-for="laborder in patientLaborders" :key="laborder._id">
                          <div @click="viewSelectedLaborder(laborder)">
                            <div class="col-12">
                              <div class="row align-items-center">
                                <div class="col-2 col-md-1">
                                  <i class="fa fa-microscope" style="font-size: 2em; color: #2ca8ff;"></i>
                                </div>
                                <div class="col-10 col-md-11">
                                  <p class="card-heading mb-0">
                                    <span v-for="labTest in laborder.labTests" :key="labTest._id">
                                      {{ labTest.name }}
                                    </span>
                                  </p>
                                  <p class="card-heading">
                                    {{ getFormattedDate(laborder.created) }}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div v-if="patientLaborders.length < 1" class="col-12 text-center">
                          <i class="fa fa-info-circle"></i>
                          {{ $t("message.No lab orders") }}
                        </div>
                      </div>
                    </div>

                    <div v-if="selectedLaborder" style="width: 100%;">
                      <n-button type="primary" round @click.native="selectedLaborder = null" icon style="position: fixed; top:10em; z-index: 1; inset-inline-start: 1em;">
                        <i class="now-ui-icons arrows-1_minimal-left"></i>
                      </n-button>
                      <view-laborder :laborder="selectedLaborder" v-if="selectedLaborder"></view-laborder>
                    </div>
                  </div>
                </div>
              </div>
            </tab-pane>
          </tabs>
        </tab-pane>

        <!-- Live vitals -->
        <tab-pane v-if="appointment.consultationType != 'telemed-direct' && !IS_CARECO" label="live-vitals">
          <template slot="label">
            <i class="fa fa-heartbeat" />
            <badge type="info" style="padding:0px; height: 18px; width: 18px; border: 2px solid white; position: absolute; top: 15px; display: none;" ref="vital-share-alert">
            </badge>
          </template>

          <div v-if="!appointmentForCurrentPatient" class="row pt-4 text-center" style="height: 100%;overflow: scroll;padding-top: 2em;font-weight: bold;">
            <div class="col-md-6 col-lg-4">
              <div v-if="IS_DOCTOR">
                <div>{{ $t("message.Select patient to view vitals") }}</div>
                <doctor-patient-svg style="height: 15em; width: 100%; margin-top: 20em"></doctor-patient-svg>
              </div>
              <div v-if="IS_NURSE" style="font-weight: bold">
                <div>{{ $t("message.Patient not added yet") }}</div>
                <doctor-patient-svg style="height: 15em; width: 100%; margin-top: 20em"></doctor-patient-svg>
              </div>
            </div>
          </div>

          <div v-if="appointmentForCurrentPatient" class="row" style="height: 100%;overflow: hidden scroll;width: 100vw;margin: 0px;">
            <div class="col-12" style="display: flex;justify-content: center;" v-if="!IS_DOCTOR">
              <drop-down tag="div" style="font-size: 1.5em;height: 2.5em;" :title="vitalDevice ? vitalDevice.displayName[$i18n.locale] || vitalDevice.displayName['en-US'] : 'Select Device'">
                <a class="dropdown-item" @click="vitalDevice = device" v-for="device in deviceProfile" :key="device.identifier">{{ device.displayName[$i18n.locale] || device.displayName['en-US'] }}</a>
              </drop-down>
            </div>
            <div class="col-md-6 col-lg-4" v-if="vitalDevice && !IS_DOCTOR" :id="vitalDevice.identifier">
              <vital-card :deviceforcard="vitalDevice" :vitals="vitalDevice.vitals" ref="vitalComponents" v-if="vitalDevice.communication.communicationMethod != 'NOTIFY'" :error-messages="errorMessages" :allowManualEntry="true" :allowRetrieval="true" :hideVitalHistory="false" :historic-vitals="historicVitals" :disableInputs="IS_DOCTOR ? true : false" :shareVitals="shareVitals" :shareButton="true" :vital-group="false"></vital-card>

              <span v-if="vitalDevice && vitalDevice.vitalsGroup" style="width:100%">
                <div class="col-md-6 col-lg-4" v-for="group in  vitalDevice.vitalsGroup" :key="group.identifier" style="padding:0px">
                  <vital-card :deviceforcard="vitalDevice" :vitals="group.vitals" ref="vitalComponents" v-if="vitalDevice.communication.communicationMethod != 'NOTIFY'" :error-messages="errorMessages" :allowManualEntry="true" :allowRetrieval="true" :hideVitalHistory="false" :historic-vitals="historicVitals" :disableInputs="IS_DOCTOR ? true : false" :shareVitals="shareVitals" :shareButton="true" :vital-group="true" :vital-group-identifier="group.identifier"></vital-card>
                </div>
              </span>
            </div>
            <span style="width:100%" v-if="IS_DOCTOR">
              <div class="col-md-6 col-lg-4" v-for="(device, index) in deviceProfile" :key="device.identifier" :id="device.identifier" style="padding:0px">
                <vital-card :deviceforcard="device" :vitals="device.vitals" :vital-index="index" ref="vitalComponents" v-if="device.communication.communicationMethod != 'NOTIFY'" :error-messages="errorMessages" :allowManualEntry="true" :allowRetrieval="false" :hideVitalHistory="false" :historic-vitals="historicVitals" :disableInputs="IS_DOCTOR ? true : false" :shareVitals="shareVitals" :shareButton="true" :vital-group="false"></vital-card>
              </div>
            </span>
          </div>
        </tab-pane>

        <!-- File Share -->
        <tab-pane label="file-share">
          <template slot="label">
            <i class="fa fa-file" />
            <badge type="info" style="padding:0px; height: 18px; width: 18px; border: 2px solid white; position: absolute; top: 15px; display: none;" ref="file-share-alert">
            </badge>
          </template>

          <div v-if="!appointmentForCurrentPatient" class="row pt-4 text-center" style="height: 100%;overflow: scroll;padding-top: 2em;font-weight: bold;">
            <div class="col-md-6 col-lg-4">
              <div v-if="IS_DOCTOR">
                <div>{{ $t("message.Select patient to share files") }}</div>
                <doctor-patient-svg style="height: 15em; width: 100%; margin-top: 20em"></doctor-patient-svg>
              </div>
              <div v-if="IS_NURSE" style="font-weight: bold">
                <div>{{ $t("message.Patient not added yet") }}</div>
                <doctor-patient-svg style="height: 15em; width: 100%; margin-top: 20em"></doctor-patient-svg>
              </div>
            </div>
          </div>

          <div v-if="appointmentForCurrentPatient" style="height: 100%;position:relative;">
            <div class="col-12 pt-5 text-center" v-if="!files || files.length < 1">
              {{ $t("message.No files shared yet") }}
            </div>
            <div style="height:calc(100% - 82px);overflow: scroll;" v-if="files && files.length > 0">
              <div class="col-12 file-list" v-for="(file, index) in files" :key="file.fileId">
                <div>
                  <div class="col-12">
                    <div class="row">
                      <div class="col-2 col-md-2 col-lg-2" @click="viewFile(file)">
                        <div v-if="file.type.indexOf('image') > -1">
                          <dynamic-image :file-id="file.fileId" image-style="min-height: 20px; width: 100%">
                          </dynamic-image>
                        </div>
                        <div v-else-if="file.type.indexOf('pdf') > -1">
                          <i class="fa fa-file-pdf" style="font-size: 2em; color: #208fdc"></i>
                        </div>
                        <div v-else-if="file.type.indexOf('video') > -1">
                          <i class="fa fa-file-video" style="font-size: 2em; color: #208fdc"></i>
                        </div>
                        <div v-else-if="file.type.indexOf('audio') > -1">
                          <i class="fa fa-file-audio" style="font-size: 2em; color: #208fdc"></i>
                        </div>
                        <div v-else>
                          <i class="fa fa-file" style="font-size: 2em; color: #208fdc"></i>
                        </div>
                      </div>
                      <div class="col-8 col-md-8 col-lg-8" @click="viewFile(file)">
                        <p style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" class="card-heading reason">{{ file.name }}</p>
                        <p class="card-heading file-date">
                          {{ getFormattedDate(file.created) }}
                        </p>
                      </div>
                      <div class="col-2 col-md-2 col-lg-2" style="color: red" @click="deleteFile(file, index)">
                        <i class="el-icon-delete"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <infinite-loading spinner="waveDots" @infinite="getFiles">
                <span slot="no-more">{{ $t("message.No more files") }}</span>
                <span slot="no-results"></span>
              </infinite-loading>
            </div>

            <!-- Button -->
            <div v-if="appointmentForCurrentPatient && appointmentForCurrentPatient.patient && appointmentForCurrentPatient.patient.patientId" class="pb-2 text-center file-share-buttons" :style="(!files || files.length < 1) ? { bottom: 'calc(100% - 40vh)' } : { bottom: '0' }">
              <n-button style="margin-right:1em;" type="primary" round @click.native="browseFiles">
                <i class="fa fa-upload"></i>
                {{ $t("message.Select") }}
              </n-button>

              <!-- Commenting this to avoid vmaatu video call issue-->
              <!-- <n-button type="primary" round @click.native="openCameraForFileUpload">
                <i class="fa fa-camera"></i>
                {{ $t("message.Capture") }}
              </n-button> -->

              <n-button type="primary" round @click.native="openCameraModalForFileUpload">
                <i class="fa fa-camera"></i>
                {{ $t("message.Capture") }}
              </n-button>

              <div style="font-size: 0.8em;color: red;font-style: italic;">*{{ $t("message.Maximum file size allowed is 10MB!") }}</div>
            </div>

            <!-- camera component -->
            <app-camera :showCam="SHOW_CAPTURE_MODAL" ref="camera" @closeCamera="closeCaptureModal" @imageCaptured="saveImage">
            </app-camera>

            <!-- Button -->
            <!-- <div style="
                  top: auto;
                  inset-inline-end: 10px;
                  bottom: 60px;
                  left: auto;
                  position: absolute;
                  display: grid;
                  transition: visibility 0s, opacity 0.5s linear;
                  z-index: 999;
                " v-if="SHOW_FILE_UPLOAD_BUTTONS">
              <n-button style="margin-bottom: 0" type="primary" social icon round size="lg" @click.native="browseFiles">
                <i class="fa fa-upload"></i>
              </n-button>
              <n-button type="primary" social icon round size="lg" @click.native="openCameraForFileUpload">
                <i class="fa fa-camera"></i>
              </n-button>
            </div> -->

            <!-- <span v-if="SHOW_FILE_UPLOAD_BUTTONS" class="file-size-msg">*{{ $t("message.Maximum file size allowed is 10MB!") }}</span>

            <n-button type="info" social icon round size="lg" @click.native="
                  SHOW_FILE_UPLOAD_BUTTONS = !SHOW_FILE_UPLOAD_BUTTONS
                " style="
                  top: auto;
                  inset-inline-end: 10px;
                  bottom: 0;
                  left: auto;
                  position: absolute;
                  z-index: 999;
                ">
              <i v-if="!SHOW_FILE_UPLOAD_BUTTONS" class="fa fa-plus"></i>
              <i v-if="SHOW_FILE_UPLOAD_BUTTONS" class="fa fa-minus"></i>
            </n-button> -->

            <!-- <div class="col-12">
              <n-pagination v-if="filesPagination.totalPages>1" :page-count="filesPagination.totalPages" v-model="filesPagination.pageNumber"></n-pagination>
            </div> -->
          </div>
        </tab-pane>

        <!-- Prescription -->
        <tab-pane label="prescription" v-if="!IS_CARECO">
          <template slot="label">
            <i class="fa fa-file-prescription" />
            <badge type="info" style="padding:0px; height: 18px; width: 18px; border: 2px solid white; position: absolute; top: 15px; display: none;font-size: xx-small;" ref="prescription-share-alert">
            </badge>
          </template>

          <div class="row" style="height: 100%;">

            <div class="col-12 mb-2 text-center pt-3" v-if="!patient && IS_DOCTOR">
              <span style="font-weight: bold;">Select Patient to proceed with prescription</span>
              <doctor-patient-svg style="height: 15em; width: 100%; margin-top: 20em"></doctor-patient-svg>
            </div>

            <!--Diagnostic summary -->
            <div class="col-12 mb-2" v-if="appointmentForCurrentPatient && appointmentForCurrentPatient.vitals && appointmentForCurrentPatient.patient.firstName && HAS_VITALS">
              <div class="row">
                <div class="col-12">
                  <div class="col-12">
                    <h6 style="text-transform: none;">{{ $t("message.Diagnostic Summary") }}</h6>
                  </div>
                  <div class="col-12" style="margin-top: 1em">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-6">
                          <div class="row" v-for="(vital, vitalName) in appointmentForCurrentPatient.vitals" :key="vital.name" v-hide="vital.value == '' || vital.value == '--'" style="border-right: 1px solid #eee">
                            <div v-if="vitalName.toLowerCase() != 'ecg' &&
                              vital.value
                              " class="col-12">
                              <span>{{ vital.name }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="row" v-for="(vital, vitalName) in appointmentForCurrentPatient.vitals" :key="vital.identifier" v-hide="vital.value == '' || vital.value == '--'" style="border-right: 1px solid #eee">
                            <div v-if="vitalName.toLowerCase() != 'ecg' &&
                              vital.value
                              " class="col-12">
                              <div>
                                <span class="value ng-binding ng-scope">{{
                                  vital.value
                                }}</span>&nbsp;
                                <span>{{ vital.unit }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Prescriptions -->
            <div class="col-12" v-show="!IS_DOCTOR || appointmentForCurrentPatient">
              <prescription :appCamera='true' ref="prescriptionDetails" @attachementCaptured="closePrescriptionCaptureModal" @openCameraModal='openCameraForPrescriptionAttachment' :prescription="prescription.prescriptions" :editable="IS_DOCTOR ? true : false"></prescription>
            </div>
            <div class="row" v-if="IS_NURSE || IS_PATIENT">
              <div class="col-12 text-center">
                <n-button type="primary" round style="margin-inline-start: 2.5em" @click.native="downloadPrescription()" v-if="HAS_PRESCRIPTION">
                  <i class="fa fa-print"></i>
                  {{ $t("message.Download Prescription") }}
                </n-button>
              </div>
            </div>
            <div v-if="IS_DOCTOR && appointmentForCurrentPatient" style="position: absolute; bottom: 0; inset-inline-end: 0.5em; z-index: 1;">
              <div>
                <n-button type="primary" round icon size='lg' @click.native="postponePrescription()">
                  <i class="fa fa-history fa-flip-horizontal" style="transform: scaleX(-1) translateX(50%) translateY(-50%);"></i>
                </n-button>
              </div>
              <div class="text-center">
                <n-button type="primary" round icon size='lg' @click.native="previewPrescription()" v-if="HAS_PRESCRIPTION || HAS_ATTACHMENTS">
                  <i class="fa fa-share-alt"></i>
                </n-button>
              </div>
            </div>

          </div>
        </tab-pane>
      </tabs>
    </div>

    <div class="appointment-contron-buttons">
      <el-button circle class="btn-success" @click.native="makeVideoCall()" v-if="!['Closed', 'Completed', 'Postponed'].includes(appointment.latestStatus) && chatMode && !showVideo">
        <i class="fa fa-video" />
      </el-button>

      <el-button circle class="btn-success" @click.native="makeTelemedAudioCall()" v-if="!['Closed', 'Completed'].includes(appointment.latestStatus) && chatMode && IS_DOCTOR && settings.pstnSettings &&
        settings.pstnSettings.enabled">
        <i class="fas fa-phone-alt"></i>
      </el-button>

      <el-button circle class="btn-success" v-if="IS_DOCTOR &&
        settings.pstnSettings &&
        settings.pstnSettings.enabled && !chatMode
        " @click.native="makeAudioCall()">
        <i class="fas fa-phone-alt"></i>
      </el-button>

      <span v-if="!IS_CARECO" style="margin-left: 0.8em;">
        <el-button v-if="chatMode && !IS_NURSE && !IS_PATIENT" class="close-button btn-danger" @click.native="showConfirmationModal = true" circle>
          <i style="width: 1em; height: 1em;" class="fas fa-times"></i>
        </el-button>

        <el-button v-else @click.native="IS_PATIENT ? askConfirmationForPatient() : askConfirmation()" class="close-button btn-danger" circle>
          <i style="width: 1em; height: 1em;" class="fas fa-times"></i>
        </el-button>
      </span>

      <el-button v-if="IS_CARECO" class="close-button btn-danger" @click.native="askConfirmationForCareco()" circle>
        <i style="width: 1em; height: 1em;" class="fas fa-times"></i>
      </el-button>
    </div>

    <modal :show.sync="SHOW_PRESCRIPTION_PREVIEW" headerclasses="justify-content-center" :showClose="false">
      <h6 slot="header" class="title title-up">{{ $t("message.Prescription Preview") }}</h6>
      <div id="prescription-viewer-wrapper" style="height: 75vh; overflow: scroll" v-loading="LOADING_PRESCRIPTION">
        <div style="margin: 2em; font-size: 6px">
          <div>
            <img :src="headerImage" alt="" srcset="">
          </div>

          <div class="details-row" style="display: flex; justify-content: space-between;">
            <div class="patient-details" v-if="appointment.patient && appointment.patient.firstName">
              <div>MRN: {{ appointment.patient.patientId }}</div>
              <div>NAME: {{ appointment.patient.firstName }} {{ appointment.patient.lastName }}</div>
              <div>AGE: {{ patientDOB }} </div>
              <div>GENDER: {{ (appointment.patient.gender).charAt(0).toUpperCase() + (appointment.patient.gender).substr(1).toLowerCase() }}</div>
            </div>
            <div v-if="appointment.provider" class="doctor-details">
              <div>DATE: {{ doctAppointmentDate }}</div>
              <div>CONSULTANT: Dr. {{ appointment.provider.firstName }} {{ appointment.provider.lastName }}</div>
              <div>SPECIALITY: {{ appointment.provider.specialityText }}</div>
              <div>{{ appointment.provider.UIN ? ("\n" + "REG NO/UIN" + ": " + appointment.provider.UIN) : "" }}</div>
            </div>
          </div>

          <div v-if="appointmentForCurrentPatient && appointmentForCurrentPatient.vitals && appointmentForCurrentPatient.patient.firstName && HAS_VITALS">
            <h3 style="background: #dcdcdc;">{{ $t("message.Diagnostic Summary") }}</h3>
            <div class="col-12" style="margin-top: 1em">
              <div class="col-12">
                <div class="row">
                  <div class="col-6">
                    <div class="row" v-for="(vital, vitalName) in appointmentForCurrentPatient.vitals" :key="vital.name" v-hide="vital.value == '' || vital.value == '--'" style="border-right: 1px solid #eee">
                      <div v-if="vitalName.toLowerCase() != 'ecg' &&
                        vital.value
                        " class="col-12">
                        <span>{{ vital.name }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="row" v-for="(vital, vitalName) in appointmentForCurrentPatient.vitals" :key="vital.identifier" v-hide="vital.value == '' || vital.value == '--'" style="border-right: 1px solid #eee">
                      <div v-if="vitalName.toLowerCase() != 'ecg' &&
                        vital.value
                        " class="col-12">
                        <div>
                          <span class="value ng-binding ng-scope">{{
                            vital.value
                          }}</span>&nbsp;
                          <span>{{ vital.unit }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- descriptiveNotes -->
          <div v-if="prescription.prescriptions.descriptiveNotes">
            <h3 style="background: #dcdcdc;">{{ $t("message.Descriptive Notes") }} </h3>
            <div>
              <p>{{ prescription.prescriptions.descriptiveNotes }}</p>
            </div>
          </div>

          <!-- Chief Complaints -->
          <div v-if="prescription.prescriptions.chiefComplaints">
            <h3 style="background: #dcdcdc;">{{ $t("message.Chief Complaints") }}</h3>
            <div>
              <p>{{ prescription.prescriptions.chiefComplaints }}</p>
            </div>
          </div>

          <!-- Relevant Points from History -->
          <div v-if="prescription.prescriptions.relevantPointsfromHistory">
            <h3 style="background: #dcdcdc;">{{ $t("message.Relevant Points from History") }}</h3>
            <div>
              <p>{{ prescription.prescriptions.relevantPointsfromHistory }}</p>
            </div>
          </div>

          <!-- Examination/Lab Findings -->
          <div v-if="prescription.prescriptions.labFindings">
            <h3 style="background: #dcdcdc;">{{ $t("message.Examination/Lab Findings") }}</h3>
            <div>
              <p>{{ prescription.prescriptions.labFindings }}</p>
            </div>
          </div>

          <!-- Provisionnal Diagnosis -->
          <div v-if="prescription.prescriptions.provisionalDiagnosis && (prescription.prescriptions.provisionalDiagnosis.notes || prescription.prescriptions.provisionalDiagnosis.icdCodes.length > 0)">
            <h3 style="background: #dcdcdc;">{{ $t("message.Diagnosis or Provisional Diagnosis") }} </h3>
            <div>
              <p>{{ prescription.prescriptions.provisionalDiagnosis.notes }}</p>
              <p v-if="(prescription.prescriptions.provisionalDiagnosis.icdCodes).length > 0">{{ $t("message.ICD Codes") }}</p>
              <ul>
                <li v-for="icd in prescription.prescriptions.provisionalDiagnosis.icdCodes" :key="icd">{{ icd.Code }} - {{ icd.Description }} </li>
              </ul>
            </div>
          </div>

          <!-- Rx prescription -->
          <div v-if="(prescription.prescriptions.rx).length > 0">
            <h3 style="background: #dcdcdc;">{{ $t("message.RX Prescription") }}</h3>
            <div class="prescription-content">
              <div v-for="drug in prescription.prescriptions.rx" :key="drug">
                <p> {{ drug.name }} </p>
                <div>{{ drug.routeOfAdministration }}</div>
                <div>{{ drug.instruction }}</div>

                <div style="display: flex; justify-content: space-between;">
                  <div> {{ drug.frequency ? ((drug.frequency.durationNo || drug.frequency.duration == 'Till Next Visit') ? ((drug.frequency.duration != 'Till Next Visit' && drug.frequency.duration) ? 'For ' + (drug.frequency.durationNo ? drug.frequency.durationNo + " - " + drug.frequency.duration + " " : "") : drug.frequency.duration) : "") + (drug.frequency.day ? " " + drug.frequency.day : "") : "" }} </div>
                  <div> {{ drug.frequency && drug.frequency.when ? ((drug.frequency.minutes ? drug.frequency.minutes + " Mins " : "") + (drug.frequency.when ? "- " + drug.frequency.when : "")) : "" }} </div>
                  <div style="display: flex;">
                    <div style="margin: 2px; text-align: center;">
                      <div>
                        M
                      </div>
                      <div style="height: 2.5em; width: 2.5em; border: solid 1px black;">
                        {{ drug.frequency ? (drug.frequency.morning ? (drug.frequency.morning.nos ? drug.frequency.morning.nos.toString() : "0") : "0") : " " }}
                      </div>
                    </div>
                    <div style="margin: 2px; text-align: center;">
                      <div>
                        A
                      </div>
                      <div style="height: 2.5em; width: 2.5em; border: solid 1px black;">
                        {{ drug.frequency ? (drug.frequency.afternoon ? (drug.frequency.afternoon.nos ? drug.frequency.afternoon.nos.toString() : "0") : "0") : " " }}
                      </div>
                    </div>
                    <div style="margin: 2px; text-align: center;">
                      <div>
                        E
                      </div>
                      <div style="height: 2.5em; width: 2.5em; border: solid 1px black;">
                        {{ drug.frequency ? (drug.frequency.evening ? (drug.frequency.evening.nos ? drug.frequency.evening.nos.toString() : "0") : "0") : " " }}
                      </div>
                    </div>
                    <div style="margin: 2px; text-align: center;">
                      <div>
                        N
                      </div>
                      <div style="height: 2.5em; width: 2.5em; border: solid 1px black;">
                        {{ drug.frequency ? (drug.frequency.night ? (drug.frequency.night.nos ? drug.frequency.night.nos.toString() : "0") : "0") : " " }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Lab prescription -->
          <div v-if="(prescription.prescriptions.labPrescription).length > 0">
            <h3 style="background: #dcdcdc;">{{ $t("message.Lab Prescription") }}</h3>
            <div class="">
              <ul>
                <li v-for="labPress in prescription.prescriptions.labPrescription" :key="labPress">
                  <div>
                    {{ labPress.test }} <br>
                    - {{ labPress.comment }}
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <!-- Imaging Prescription -->
          <div class="row" v-if="prescription.prescriptions.imagingPrescription &&
            prescription.prescriptions.imagingPrescription.types.length > 0
            ">
            <div class="col-12">
              <h3 style="background: #dcdcdc;">{{ $t("message.Imaging Prescription") }}</h3>
            </div>
            <div class="col-12">
              <card v-for="imagingType in prescription.prescriptions.imagingPrescription.types" class="card-nav-tabs" header-classes="card-header-warning" :key="imagingType.type">
                <div slot="header">{{ imagingType.type }}</div>
                <div>
                  <dynamic-image v-if="imagingType.imageData" :file-id="imagingType.imageData">
                  </dynamic-image>
                </div>
                <div class="row" style="font-size: x-small">
                  <div class="col-12" v-for="option in imagingType.option" :key="option">
                    <i class="fa fa-check-square"></i>
                    {{ option }}
                  </div>

                  <span v-if="imagingType.comment" class="col-12">
                    <span>{{ $t("message.Notes") }}</span>
                    {{ imagingType.comment }}
                  </span>
                </div>
              </card>
            </div>
          </div>

          <!-- Other comments -->
          <div v-if="prescription.prescriptions.otherComments">
            <h3 style="background: #dcdcdc;">
              {{ $t("message.Other Comments") }}
            </h3>
            <div>
              {{ prescription.prescriptions.otherComments }}
            </div>
          </div>

          <!-- Follow Up -->
          <div class="row" v-if="prescription.prescriptions.followup && prescription.prescriptions.followup.requested">
            <div class="col-12 col-md-12">
              <h3 style="background: #dcdcdc;">{{ $t("message.Follow up") }}</h3>
            </div>
            <div class="col-12 col-md-12">
              <div>
                <span>{{ $t("message.After") }}</span>
                {{ prescription.prescriptions.followup.durationNo }} {{ prescription.prescriptions.followup.duration }}
              </div>
              <p>{{ $t("message.Comments") }} : {{ prescription.prescriptions.followup.comments }}</p>
            </div>
          </div>

          <!-- Emergency Care -->
          <div v-if="prescription.prescriptions.emergencyCare">
            <h3 style="background: #dcdcdc;">{{ $t("message.Emergency Care") }}</h3>
            <div>
              <p>{{ prescription.prescriptions.emergencyCare }}</p>
            </div>
          </div>

          <div style="width: 40vw; float: right;">
            <dynamic-image :file-id="user.signature.image" image-class="mb-4" image-id="signature-img" image-style="margin: auto; display: block" v-if="user.signature.image">
            </dynamic-image>
            <hr>
            <span v-if="appointment.provider">Dr. {{ appointment.provider.firstName }} {{ appointment.provider.lastName }}</span>
          </div>

          <div>
            <img :src="footerImage" alt="" srcset="">
          </div>
        </div>
      </div>
      <template slot="footer">
        <n-button round @click.native="closePrescriptionPreview()">{{ $t("message.CANCEL") }}</n-button>
        <n-button type="primary" round @click.native="sharePrescription()">{{ $t("message.SHARE") }}</n-button>
      </template>
    </modal>

    <modal :show.sync="SHOW_MAIL_POPUP" headerclasses="justify-content-center" :showClose="false">
      <h6 slot="header" class="title title-up">{{ $t("message.Send as mail") }}</h6>
      <div>
        <div class="col-md-12">
          <label class="label-style">{{ $t("message.Subject") }}</label>
          <fg-input type="text" v-model="mailDetails.subject" :placeholder="$t('message.Subject')"></fg-input>
        </div>
        <div class="col-md-12">
          <label class="label-style">{{ $t("message.Patient Email") }}</label>
          <fg-input type="text" v-model="mailDetails.to" :placeholder="$t('message.Patient Email')"></fg-input>
        </div>
        <div class="col-md-12">
          <n-checkbox v-model="mailDetails.CC_TO_ME">{{
            $t("message.CC")
          }}</n-checkbox>
          <div class="col-md-12" v-if="mailDetails.CC_TO_ME">
            <fg-input type="text" v-model="mailDetails.cc" :placeholder="$t('message.CC')"></fg-input>
          </div>
        </div>
        <div class="col-md-12">
          <n-checkbox v-model="mailDetails.MAIL_PRESCRIPTION">{{
            $t("message.Summary & Prescription")
          }}</n-checkbox>
        </div>
        <div class="col-md-12" v-if="HAS_ATTACHMENTS">
          <n-checkbox v-model="mailDetails.MAIL_ATTACHMENTS">{{
            $t("message.Attachments")
          }}</n-checkbox>
        </div>
      </div>
      <template slot="footer">
        <n-button round @click.native="closeMailPopUp()">{{ $t("message.CANCEL") }}</n-button>
        <n-button type="primary" round @click.native="proceedToSendPrescription()">{{ $t("message.SEND") }}</n-button>
      </template>
    </modal>

    <!-- Create patient modal -->
    <modal v-if="SHOW_PATIENT_CREATION_MODAL" :show.sync="SHOW_PATIENT_CREATION_MODAL" headerclasses="justify-content-center" :showClose="true">
      <h5 slot="header" class="title title-up">{{ $t("message.Patient Details") }}</h5>
      <div>
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <fg-input type="text" :label="$t('message.First Name')" labelClasses="float-input-label" inputClasses="pb-1" :placeholder="$t('message.First Name')" v-model="patientForDiscussion.firstName" name="firstName" v-validate="modelValidations.firstName" :error="getError('firstName')"></fg-input>
            </div>
            <div class="col-12">
              <fg-input type="text" :label="$t('message.Last Name')" labelClasses="float-input-label" inputClasses="pb-1" :placeholder="$t('message.Last Name')" v-model="patientForDiscussion.lastName" name="lastName" v-validate="modelValidations.lastName" :error="getError('lastName')"></fg-input>
            </div>
            <div class="col-12 col-md-12 form-group">
              <label for="" class="mb-0 pl-1">{{ $t('message.Gender') }}</label>
              <div style="display:flex;justify-content:left;">
                <n-radio class="pr-2" v-model="patientForDiscussion.gender" label="male">{{ $t('message.Male') }}</n-radio>
                <n-radio class="pr-2" v-model="patientForDiscussion.gender" label="female">{{ $t('message.Female') }}</n-radio>
                <n-radio class="pr-2" v-model="patientForDiscussion.gender" label="others">{{ $t('message.Others') }}</n-radio>
              </div>
            </div>
            <div class="col-12 col-md-12">
              <div class="row">
                <div class="col-12 ">
                  <div style="position: relative;">
                    <fg-input name="age" type="number" :label="$t('message.Age')" labelClasses="float-input-label" v-model="patientAge" v-validate="modelValidations.age" :placeholder="$t('message.Age')" inputClasses="pb-1" :error="getError('age')">
                    </fg-input>

                    <div style="position: absolute; top: 0px; inset-inline-end: 0px; width:35%;" id="age-dropdown">
                      <el-select style="width: 100%;" class="form-group select-primary" size="large" name="latestStatus" placeholder="years" v-model="ageUnit">
                        <el-option class="select-primary" value="years" :label="$t('message.Years')"></el-option>
                        <el-option class="select-primary" value="months" :label="$t('message.Months')"></el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <VuePhoneNumberInput style="direction: ltr;" v-model="mobileNumber" :border-radius="25" default-country-code="IN" :preferred-countries="['IN']" @update="mobileNumberUpdate" />
              <div class="text-danger invalid-feedback mt-2" style="display: block" v-if="mobileNumber && !isValidMobile">
                {{ $t("message.Please enter valid mobile number") }}
              </div>
              <fg-input class="hide-input" name="mobileNumber" v-model="mobileNumber"></fg-input>
            </div>
            <div class="col-12">
              <fg-input :label="$t('message.Email')" labelClasses="float-input-label" inputClasses="pb-1" name="email" :placeholder="$t('message.Email')" v-model="patientForDiscussion.email" v-validate="modelValidations.email" :error="getError('email')"></fg-input>
            </div>

            <div class="col-12 text-center">
              <n-button type="primary" round @click.native="validatePatientDetails()" v-if="PATIENT_SELECTED == false">
                <h6 class="m-0">{{ $t("message.Save") }}</h6>
              </n-button>
            </div>
          </div>
        </div>
      </div>
    </modal>

    <div class="confirmationModal">
      <modal :show.sync="showConfirmationModal" headerClasses="justify-content-center" :showClose="true">
        <h4 slot="header" class="title title-up">{{ $t("message.Exit Chat") }}</h4>
        <!-- when prescription is made mandatory -->
        <div v-if="IS_DOCTOR && settings.mandatoryPrescription && settings.mandatoryPrescription.enabled && !PRESCRIPTION_SHARED">
          <div style="text-align: center;" class="row">
            <div class="col-12 d-flex justify-content-center">
              <p>{{ $t("message.Appointment can be completed only after prescritption is shared") }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-12 d-flex justify-content-center">
              <n-button type='info' size="md" @click.native="exitChat()">
                {{ $t("message.Prescribe later") }}
              </n-button>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="row">
            <div class="col-12 d-flex justify-content-center">
              <span>{{ $t("message.Mark Completed") }}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-12 d-flex justify-content-center">
              <n-switch v-model="markCompleted" on-text="Yes" off-text="No" color='green'></n-switch>
            </div>
          </div>
          <div class="row">
            <div class="col-12 d-flex justify-content-center">
              <p v-if="markCompleted">{{ $t("message.You will not be able to join later") }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-12 d-flex justify-content-center">
              <n-button type='info' size="md" @click.native="exitChat()">
                {{ $t("message.Exit") }}
              </n-button>
            </div>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import socket from "@/services/socket";
import moment from "moment";

import { TabPane, Tabs } from "src/components";
import ViewPrescription from "./components/ViewPrescription.vue";
import ViewLaborder from "./components/ViewLaborder.vue";
import vitalCard from "./components/VitalCard";
import PrescriptionService from "../../services/prescription.js";
import ReceiptService from "../../services/receipt.js";
import CallNotificationDiscussion from "../../components/CallNotificationDiscussion";
import { Switch } from "src/components";
import VueDragResize from "vue-drag-resize";
import AppCamera from "./components/AppCamera.vue";

import VitalsNotConfiguredSvg from "./components/svg_images/VitalsNotConfiguredSvg.vue";
import DoctorPatientSvg from "./components/svg_images/DoctorPatientSvg.vue";
import { checkAvailability } from "@ionic-native/core";

export default {
  name: "telemed",

  components: {
    TabPane,
    Tabs,
    vitalCard,
    ViewPrescription,
    CallNotificationDiscussion,
    [Switch.name]: Switch,
    VueDragResize,
    AppCamera,
    VitalsNotConfiguredSvg,
    DoctorPatientSvg,
    ViewLaborder,
  },

  data() {
    return {
      floatingVideoPositionX: 0,
      floatingVideoPositionY: window.innerHeight - 264,
      parentHeight: null,
      parentWidth: null,
      patientAge: null,
      patientAgeYears: null,
      patientAgeMonths: null,
      ageUnit: "years",
      patientProfileImage: null,
      createPatientBtnFixed: false,
      PATIENT_SELECTED: false,
      NEW_PATIENT: false,
      SHOW_PATIENT_CREATION_MODAL: false,
      mobileNumber: null,
      patientForDiscussion: {
        firstName: "",
        lastName: "",
        dob: "",
        gender: "",
      },
      hideVmaatuControls: false,
      link: "#",

      SHOW_CAPTURE_MODAL: false,
      files: [],
      simpleMeetingsQuery: null,
      prescription: {
        prescriptions: {
          attachments: [],
          descriptiveNotes: null,
          provisionalDiagnosis: {
            notes: null,
            icdCodes: [],
          },
          rx: [],
          labPrescription: [],
          followup: {
            requested: false,
          },
          imagingPrescription: { types: [] },
        },
      },
      filesPagination: {
        pageNumber: 1,
        totalPages: 0,
      },
      patient: null,
      patientSearchText: null,
      vitals: {},
      historicVitals: null,
      historicFiles: [],
      historicPrescriptions: [],
      selectedPrescription: null,
      FETCHED_HISTROIC_VITALS: false,
      loader: null,
      deviceProfile: [],
      activeTab: "chat-message",
      patientIdFile: null,
      SHOW_PRESCRIPTION_PREVIEW: false,
      LOADING_PRESCRIPTION: false,
      errorMessages: {},
      IS_DOCTOR: false,
      IS_NURSE: false,
      IS_CARECO: false,
      IS_PATIENT: false,
      appointmentEndpoint: null,
      SHOW_FILE_UPLOAD_BUTTONS: false,
      headerImage: null,
      footerImage: null,
      prescriptionDownloaded: false,
      participants: [],
      titleImageUrl:
        "https://a.slack-edge.com/66f9/img/avatars-teams/ava_0001-34.png",
      newMessagesCount: 0,
      isChatOpen: false,
      showTypingIndicator: "",
      colors: {
        header: {
          bg: "var(--color-primary)",
          text: "#ffffff",
        },
        launcher: {
          bg: "#4e8cff",
        },
        messageList: {
          bg: "#ffffff",
        },
        sentMessage: {
          bg: "var(--color-primary)",
          text: "#ffffff",
        },
        receivedMessage: {
          bg: "#eaeaea",
          text: "#222222",
        },
        userInput: {
          bg: "#f4f7f9",
          text: "#565867",
        },
      },
      alwaysScrollToBottom: false,
      messageStyling: true,
      defaultImage: "",
      carenationBotImage: "",
      callNotification: false,
      caller: {},
      callType: "",
      showVideo: false,
      outGoingCall: false,
      markCompleted: false,
      showConfirmationModal: false,
      SHOW_MAIL_POPUP: false,
      mailDetails: {},
      previewFile: {},
      showPreviewModal: false,
      CHAT_FILE_UPLOADING: false,
      disableInput: false,
      mountedLoader: null,
      doctorDisplayPic: "",
      nurseDisplayPic: "",
      provider: null,
      appointmentMessages: [],
      waitingMsg: "",
      remoteUser: null,
      PRESCRIPTION_SHARED: false,
      REMOTE_EP_PTZ_ENABLED: false,
      ptzTimer: null,
      patientLaborders: null,
      selectedLaborder: null,
      appointmentForCurrentPatient: null,
      showVideoCall: false,
      vitalDevice: null,
    };
  },

  async mounted() {
    let that = this;
    console.log(this.user);

    const mainTab = this.$refs.mainTab;
    this.parentHeight = mainTab.$el.offsetHeight;
    this.parentWidth = mainTab.$el.offsetWidth;

    this.IS_DOCTOR = this.user.roles.includes("doctor");
    this.IS_NURSE = this.user.roles.includes("nurse");
    this.IS_CARECO = this.user.roles.includes("careCoordinator");
    this.IS_PATIENT = this.user.roles.includes("patient");

    if (this.IS_DOCTOR) {
      this.showVideoCall = true;
    }

    if (this.inpersonConsultation) {
      this.onTabChange("patient-history");
    }

    if (
      this.appointment.appointmentForCurrentPatient &&
      JSON.parse(
        localStorage.getItem(
          "prescription" + this.appointment.appointmentForCurrentPatient
        )
      )
    ) {
      this.prescription = JSON.parse(
        localStorage.getItem(
          "prescription" + this.appointment.appointmentForCurrentPatient
        )
      );
    }

    if (!this.chatMode && !this.inpersonConsultation) {
      this.activeTab = "video-call";
    }

    //Disabling landscape mode for chat tab
    if (
      this.activeTab == "chat-message" &&
      window &&
      window.screen &&
      window.screen.orientation
    ) {
      window.screen.orientation.lock("portrait");
    }

    that.$root.onBackButton = () => {
      let that = this;
      if (that.IS_CARECO) {
        that.askConfirmationForCareco();
      } else if (that.IS_PATIENT) {
        that.askConfirmationForPatient();
      } else if (that.chatMode) {
        if (that.IS_DOCTOR) {
          switch (that.activeTab) {
            case "video-call":
              that.showConfirmationModal = true;
              break;
            case "chat-message":
              that.showConfirmationModal = true;
              break;
            case "patient-history":
            case "file-share":
            case "live-vitals":
            case "prescription":
              that.closePrescriptionPreview();
              that.showConfirmationModal = true;
              break;
          }
        } else if (that.IS_NURSE) {
          switch (that.activeTab) {
            case "video-call":
              that.askConfirmation();
              break;
            case "chat-message":
              that.askConfirmation();
              break;
            case "patient-history":
            case "file-share":
            case "live-vitals":
            case "prescription":
              that.closePrescriptionPreview();
              that.askConfirmation();
              break;
          }
        }
      } else {
        switch (that.activeTab) {
          case "video-call":
            that.askConfirmation();
            break;
          case "patient-history":
          case "file-share":
          case "live-vitals":
          case "prescription":
            that.closePrescriptionPreview();
            that.askConfirmation();
            break;
        }
      }
    };
    this.initSocket();
    // Calling socket handlers early to fix ringing issue
    this.initSocketHandlers();

    this.mountedLoader = that.$loading.show({
      container: null,
      canCancel: false,
      backgroundColor: "white",
    });
    if (
      this.settings.directTelemedicine.consultancyParadigm == "chat" &&
      this.activeTab == "chat-message"
    ) {
      this.changeAppHeaderText(this.activeTab);
    } else {
      this.changeAppHeaderText("video-call");
    }

    //Get Appointment messages
    if (this.appointment) {
      let response = await this.$store.dispatch(
        "getAppointmentMessages",
        this.appointment._id
      );
      this.appointmentMessages = response;
    }

    try {
      this.defaultImage = require("@/assets/img/proAvatar.png");
      this.carenationBotImage = require("@/assets/img/carenation-logo.png");

      try {
        this.headerImage = await this.$store.dispatch(
          "getFileAsDataUrl",
          this.$store.state.settings.prescriptionHeaderImage
        );

        this.footerImage = await this.$store.dispatch(
          "getFileAsDataUrl",
          this.$store.state.settings.footerImage
        );
      } catch (e) {
        console.log(e);
        swal.fire({
          type: "warning",
          title: this.$t("message.Prescription header/footer missing"),
          text: this.$t(
            "message.Prescription sharing may not work Contact Administrator"
          ),
          timer: 3000,
        });
      }

      window.initSocket = this.initSocket;

      //Get appointment files
      this.getFiles();
      //get Vital History
      // await this.getVitalHistory();

      if (this.IS_NURSE) {
        this.waitingMsg = "Connecting video. Please wait...";
      } else if (this.IS_DOCTOR) {
        this.waitingMsg = "Connecting video. Please wait...";
      }

      if (typeof this.user.endpoint == "string") {
        await this.$store.dispatch("getEndpoint", this.user.endpoint);
      }

      if (
        !this.user.endpoint ||
        this.user.endpoint.videoConfEPType == "VMAATU_RTC"
      ) {
        let simpleMeetingsQuery = {
          api_key: this.settings.vMaatuSettings.apikey,
          room_name: this.instance + "_" + this.appointment._id,
          user_name: this.user.username,
          tenant_name: this.user.tenant.name,
          instance: this.instance,
        };

        if (
          this.user.roles.includes("doctor") &&
          this.settings.vMaatuSettings.recordingEnabled &&
          this.user.endpoint.cameraSetting.recordingEnabled
        ) {
          simpleMeetingsQuery.enable_recording = "true";

          if (this.settings.vMaatuSettings.recordingResolution) {
            simpleMeetingsQuery.recording_resolution =
              this.settings.vMaatuSettings.recordingResolution;
          }

          if (this.settings.vMaatuSettings.recordingFrameRate) {
            simpleMeetingsQuery.recording_frame_rate =
              this.settings.vMaatuSettings.recordingFrameRate;
          }

          if (this.settings.vMaatuSettings.autoRecordingEnabled) {
            simpleMeetingsQuery.auto_recording = "true";
          }
        }

        this.simpleMeetingsQuery = simpleMeetingsQuery;

        if (
          (this.appointment.preferredVideoCodec &&
            this.appointment.preferredVideoCodec == "h264") ||
          device.platform == "iOS"
        ) {
          this.simpleMeetingsQuery.video_encoding = "h264";
          socket.emit("vmaatuVideoEncodingUpdate", {
            appointmentId: this.appointment._id,
            encoding: "h264",
          });
        }
        if (!this.chatMode && this.showVideoCall) {
          console.log("url", simpleMeetingsQuery);
          setTimeout(() => {
            that.$refs.vmaatu.init();
            console.log("vmaatu init");
          }, 1000);
          this.goToVideoCall();
        }
      } else if (
        this.user.endpoint.videoConfEPType == "SPARK_EMBEDDED" &&
        this.appointment.latestStatus == "InProgress" &&
        this.IS_DOCTOR == true
      ) {
        let response = await this.$store.dispatch(
          "getAppointment",
          this.appointment._id
        );
        await this.$store.commit("setState", {
          stateName: "appointment",
          stateValue: response,
        });
        if (
          this.user.oauthInfo &&
          this.user.oauthInfo.ciscospark &&
          this.user.oauthInfo.ciscospark.accessToken
        ) {
          this.simpleMeetingsQuery = {
            api_key: this.settings.vMaatuSettings.apikey,
            room_name: this.instance + "_" + this.appointment._id,
            user_name: this.user.username,
            tenant_name: this.user.tenant.name,
            access_token: this.user.oauthInfo.ciscospark.accessToken,
            destination: this.appointment.webexTeams.roomId,
          };
          this.showVideo = true;

          //Patient has to join after doctor to make webex video call work
          setTimeout(() => {
            socket.emit("appointmentJoined", {
              appointmentId: this.appointment._id,
              endpointId: this.appointment.endpoint,
              userId: this.user._id,
            });
            socket.emit("appointmentJoined", {
              appointmentId: this.appointment._id,
              specialityId: this.appointment.specialityId,
              userId: this.user._id,
            });
          }, 20000);
        } else {
          localStorage.setItem("user", null);
          that.$router.push("signin");
        }
      } else if (
        this.user.endpoint.videoConfEPType == "SPARK_EMBEDDED" &&
        this.appointment.latestStatus == "InProgress"
      ) {
        let webexTokens = await that.$store.dispatch(
          "getValidWebexGuestAccessToken"
        );

        if (webexTokens) {
          this.simpleMeetingsQuery = {
            api_key: this.settings.vMaatuSettings.apikey,
            room_name: this.instance + "_" + this.appointment._id + "_doctor",
            user_name: this.user.username,
            tenant_name: this.user.tenant.name,
            access_token: webexTokens.accessToken,
            destination: this.appointment.webexTeams.roomId,
          };
          this.showVideo = true;
        } else {
          localStorage.setItem("user", null);
          that.$router.push("signin");
        }
      }

      if (
        this.appointment &&
        this.appointment.appointmentType == "Discussion" &&
        this.appointment.appointmentForCurrentPatient
      ) {
        this.appointmentForCurrentPatient = await this.$store.dispatch(
          "getAppointmentById",
          this.appointment.appointmentForCurrentPatient
        );
        this.appointment.patient = this.appointmentForCurrentPatient.patient;
        await this.getHistoricPatientData();
      }

      this.mountedLoader.hide();
      this.mountedLoader = null;

      try {
        if (this.appointment.endpoint) {
          this.appointmentEndpoint = await this.$store.dispatch(
            "getEndpoint",
            this.appointment.endpoint
          );

          if (
            this.appointmentEndpoint &&
            this.appointmentEndpoint.cameraSetting &&
            this.appointmentEndpoint.cameraSetting.ptzEnabled
          ) {
            this.REMOTE_EP_PTZ_ENABLED = true;
          }

          //get device profile from configurations
          let response = await this.$store.dispatch(
            "getConfigurationByEndpointId",
            {
              endpointId: this.appointmentEndpoint._id,
              type: "deviceProfile",
            }
          );
          if (response && response.value) {
            this.deviceProfile = response.value;
            if (this.deviceProfile.length > 0 && this.IS_NURSE) {
              for (let vitalDevice of this.deviceProfile) {
                if (vitalDevice.vitalsGroup) {
                  for (let vital of vitalDevice.vitalsGroup) {
                    let vitals = [];
                    if (vital.vitals) {
                      for (let _vital of vital.vitals) {
                        let v = vitalDevice.vitals.find(
                          (element) => element.identifier == _vital
                        );
                        if (v) {
                          vitals.push(v);
                          vitalDevice.vitals = vitalDevice.vitals.filter(
                            (element) => element.identifier != _vital
                          );
                        }
                      }
                    }
                    vital.vitals = vitals;
                  }
                }
              }
              this.vitalDevice = this.deviceProfile[0];
            }
          }

          this.deviceProfile.forEach((device) => {
            device.vitals.forEach((vital) => {
              this.$set(this.errorMessages, vital.identifier, []);

              //Setting device vitals values from appointment vitals if exists
              if (this.appointment.vitals) {
                for (let vitalKey in this.appointment.vitals) {
                  if (vitalKey == vital.identifier) {
                    vital.value = this.appointment.vitals[vitalKey].value;
                  }
                }
              }
            });

            if (device.vitalsGroup) {
              device.vitalsGroup.forEach((group) => {
                if (group.vitals) {
                  group.vitals.forEach((vital) => {
                    this.$set(this.errorMessages, vital.identifier, []);

                    //Setting device vitals values from appointment vitals if exists
                    if (this.appointment.vitals) {
                      for (let vitalKey in this.appointment.vitals) {
                        if (vitalKey == vital.identifier) {
                          vital.value = this.appointment.vitals[vitalKey].value;
                        }
                      }
                    }
                  });
                }
              });
            }
          });
        }
      } catch (e) {
        console.log(e);
      }

      this.IS_APPOINTMENT_CREATED_BY_DOCTOR =
        this.appointment.consultationType != "telemed-direct" &&
        this.appointment.attendant
          ? this.appointment.attendant.username == this.user.username
          : false;

      if (this.chatMode) {
        if (this.appointment.consultationType == "telemed-direct") {
          this.participants.push({
            id: this.appointment.patient.patientId,
            name:
              this.appointment.patient.firstName +
              " " +
              this.appointment.patient.lastName,
            imageUrl: require("@/assets/img/proAvatar.png"),
          });
        } else {
          if (this.appointment.user && this.appointment.createdBy == "nurse") {
            try {
              this.nurseDisplayPic = require("@/assets/img/proAvatar.png");
              this.nurse = await this.$store.dispatch(
                "getUserById",
                this.appointment.user
              );
              console.log("nurse--", this.nurse);
              if (this.nurse.profileImage) {
                this.nurseDisplayPic = `${this.$store.state.baseUrl}/file/${this.nurse.profileImage}`;
              }
              if (this.nurse) {
                this.participants.push({
                  id: this.nurse.username,
                  name: this.nurse.firstName + " " + this.nurse.lastName,
                  imageUrl: this.nurseDisplayPic,
                });
              }
            } catch (e) {
              console.log(e);
            }
          }
        }
        if (this.settings.brandLogoMini) {
          this.carenationBotImage = `${this.$store.state.baseUrl}/file/${this.settings.brandLogoMini}`;
        }
        this.participants.push({
          id: "carenation-bot",
          name: "Carenation bot",
          imageUrl: this.carenationBotImage,
        });
        console.log("user", this.user);

        if (this.IS_CARECO || this.IS_NURSE) {
          this.doctorDisplayPic = require("@/assets/img/proAvatar.png");
          try {
            this.provider = await this.$store.dispatch(
              "getUserById",
              this.appointment.provider.providerId
            );
            console.log("provider--", this.provider);
            if (this.provider.profileImage) {
              this.doctorDisplayPic = `${this.$store.state.baseUrl}/file/${this.provider.profileImage}`;
            }
            console.log("doc--", this.doctorDisplayPic);
            this.participants.push({
              id: this.appointment.provider.username,
              name:
                this.appointment.provider.firstName +
                " " +
                this.appointment.provider.lastName,
              imageUrl: this.doctorDisplayPic,
            });
          } catch (e) {
            console.log(e);
          }
          for (let associate of this.provider.associations) {
            if (associate.associationType == "assistant") {
              socket.emit("appointmentListUpdate", {
                assistantId: associate.associatedUser,
              });
              if (associate.associatedUser != this.user._id) {
                this.participants.push({
                  id: associate.associatedUserUserName,
                  name: associate.associatedUserFullName,
                  imageUrl: associate.associatedUserProfileImage
                    ? `${this.$store.state.baseUrl}/file/${associate.associatedUserProfileImage}`
                    : require("@/assets/img/proAvatar.png"),
                });
              }
            }
          }
        } else {
          for (let associate of this.user.associations) {
            if (associate.associationType == "assistant") {
              this.participants.push({
                id: associate.associatedUserUserName,
                name: associate.associatedUserFullName,
                imageUrl: associate.associatedUserProfileImage
                  ? `${this.$store.state.baseUrl}/file/${associate.associatedUserProfileImage}`
                  : require("@/assets/img/proAvatar.png"),
              });
            }
          }
        }

        console.log("participatns--", this.participants);

        for (let i = this.appointmentMessages.length - 1; i >= 0; i--) {
          if (
            this.appointmentMessages[i].content &&
            this.appointmentMessages[i].content == "Video call"
          ) {
            if (
              this.appointmentMessages[i].status == "accepted" &&
              (this.appointmentMessages[i].username == this.user.username ||
                this.appointmentMessages[i].username ==
                  this.appointment.patient.patientId)
            ) {
              for (let participant of this.participants) {
                if (
                  participant.id == this.appointment.chatMessages[i].username
                ) {
                  this.remoteUser = participant;
                }
              }
              if (this.remoteUser == null) {
                for (let participant of this.participants) {
                  if (
                    this.appointment.chatMessages[i].username ==
                      this.user.username &&
                    participant.id == this.appointment.chatMessages[i].to
                  ) {
                    this.remoteUser = participant;
                  }
                }
              }
              console.log("remoteUser -- ", this.remoteUser);
              this.showVideo = true;
              this.goToVideoCall();
              this.hideVmaatuControls = false;
              setTimeout(() => {
                that.$refs.vmaatu.init();
                console.log("vmaatu init");
              }, 1000);
            }
            break;
          }
        }
        if (this.IS_DOCTOR) {
          this.sendDoctorJoinedMessage();
        }
        if (this.IS_CARECO) {
          this.sendAssistantJoinedMessage();
        }
        if (!this.IS_PATIENT) {
          let response = await this.$store.dispatch(
            "clearUnreadMessagesCount",
            {
              appointmentId: this.appointment._id,
              userId: this.user._id,
            }
          );
          if (response && response._id) {
            await this.$store.commit("setState", {
              stateName: "appointment",
              stateValue: response,
            });
          }
        }

        if (["Closed", "Completed"].includes(this.appointment.latestStatus)) {
          this.disableInput = true;
        }
      }
      if (this.IS_NURSE) {
        if (
          this.appointment.latestStatus == "Assigned" &&
          !this.showVideoCall
        ) {
          this.provider = await this.$store.dispatch(
            "getUserById",
            this.appointment.provider.providerId
          );
          console.log("provider--", this.provider);
          if (this.provider.profileImage) {
            this.caller.img = `${this.$store.state.baseUrl}/file/${this.provider.profileImage}`;
          } else {
            this.caller.img = this.defaultImage;
          }
          this.caller.name =
            "Dr. " + this.provider.firstName + " " + this.provider.lastName;
          this.callType = "outgoing";
          this.callNotification = true;
          this.outGoingCall = true;
        } else {
          this.showVideoCall = true;
          this.callNotification = false;
          setTimeout(() => {
            that.$refs.vmaatu.init();
            console.log("vmaatu init");
          }, 1000);
          this.goToVideoCall();
        }
      }
    } catch (error) {
      console.log(error);
      this.mountedLoader.hide();
      this.mountedLoader = null;
    }
    console.log("Settings : ", this.settings);
  },

  beforeDestroy() {
    this.$root.onBackButton = null;
    if (this.$refs.vmaatu) {
      this.$refs.vmaatu.destroy();
    }
    if (this.chatMode) {
      socket.emit("chatTyping", {
        appointmentId: this.appointment._id,
        userId: this.user.username,
        typing: false,
      });
    }

    // leave room was in the "if(this.chatMode)" above, not sure why
    socket.emit("leaveRoom", {
      type: "appointment",
      id: this.appointment._id,
      userId: this.user._id,
    });

    socket.off("appointmentExit");
    socket.off("appointmentJoined");
    socket.off("filesUpdate");
    socket.off("vitalsUpdate");
    socket.off("appointmentPatientUpdate");

    window.initSocket = null;
  },

  computed: {
    modelValidations() {
      return {
        firstName: {
          required: true,
        },
        lastName: {
          required: true,
        },
        gender: {
          required: true,
        },
        age: {
          required: true,
          min_value: 1,
          max_value: this.ageUnit == "years" ? 120 : 11,
        },
      };
    },
    appointment() {
      return this.$store.state.appointment;
    },
    showRipple() {
      if (this.activeTab != "video-call" && this.showVideoCall) {
        return true;
      } else {
        return false;
      }
    },
    settings() {
      return this.$store.state.settings;
    },
    vmaatuClass() {
      if (this.activeTab == "video-call") {
        return "fullscreen-window";
      } else {
        if (!this.mountedLoader) {
          return "draggable-window";
        } else {
          return "fullscreen-window";
        }
      }
    },
    draggable() {
      return this.activeTab == "video-call" ? false : true;
    },
    preventActiveBehavior() {
      return this.activeTab == "video-call" ? true : false;
    },
    contentClass() {
      return this.activeTab == "video-call"
        ? "non-draggable-content"
        : "draggable-content";
    },
    chatMode() {
      if (this.appointment.appointmentType == "Discussion") {
        return false;
      }
      if (this.appointment.consultationType == "telemed-direct") {
        if (this.settings.directTelemedicine.consultancyParadigm == "chat") {
          return true;
        } else {
          return false;
        }
      } else {
        if (
          this.settings.consultancyParadigm == "chat" &&
          this.appointment.consultationType == "telemedicine"
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    inpersonConsultation() {
      if (this.appointment.consultationType == "inperson") {
        return true;
      } else {
        return false;
      }
    },
    messageList() {
      let messageList = [];
      if (this.appointment) {
        for (const msg of this.appointmentMessages) {
          if (!msg.hideForDoctor) {
            if (msg.type == "text") {
              let newMessage = {
                author:
                  msg.username == this.user.username ? "me" : msg.username,
                data: { text: msg.content, meta: msg.time },
                type: msg.type,
              };
              if (msg.name != "Carenation bot") {
                newMessage["fullName"] = msg.name;
              }
              messageList.push(newMessage);
            } else if (msg.type == "file") {
              let newMessage = {
                author:
                  msg.username == this.user.username ? "me" : msg.username,
                data: {
                  file: {
                    name: msg.content,
                    url: msg.fileId,
                    type: msg.fileType,
                  },
                  meta: msg.time,
                  text: msg.text,
                },
                type: msg.type,
              };
              if (msg.name != "Carenation bot") {
                newMessage.data["fullName"] = msg.name;
              }
              messageList.push(newMessage);
            } else if (msg.type == "call" && msg.content) {
              let newMessage = {
                author:
                  msg.username == this.user.username ? "me" : msg.username,
                data: { text: msg.status, meta: { time: msg.time } },
                type: "system",
              };
              if (
                msg.username == this.user.username &&
                (msg.status == "initiated" ||
                  msg.status == "accepted" ||
                  msg.status == "ended" ||
                  msg.status == "missed")
              ) {
                newMessage.data.meta.icon = "fas fa-arrow-up";
              } else if (
                msg.username != this.user.username &&
                (msg.status == "initiated" ||
                  msg.status == "accepted" ||
                  msg.status == "ended" ||
                  msg.status == "missed")
              ) {
                newMessage.data.meta.icon = "fas fa-arrow-down";
              } else if (msg.status == "declined") {
                newMessage.data.meta.icon = "fas fa-video-slash";
              } else if (msg.status == "cancelled") {
                newMessage.data.meta.icon = "fas fa-video-slash";
              }
              if (msg.status == "missed") {
                newMessage.data.text = `Missed call ${msg.firstName} ${msg.lastName}`;
              } else if (msg.status == "declined") {
                newMessage.data.text = `Call declined ${msg.firstName} ${msg.lastName}`;
              } else if (msg.status == "cancelled") {
                newMessage.data.text = `Call cancelled ${msg.firstName} ${msg.lastName}`;
              } else if (msg.status == "initiated") {
                newMessage.data.text = `Call initiated ${msg.firstName} ${msg.lastName}`;
              } else if (msg.status == "accepted") {
                newMessage.data.text = `Call accepted ${msg.firstName} ${msg.lastName}`;
              } else if (msg.status == "ended") {
                newMessage.data.text = `Call ended ${msg.firstName} ${msg.lastName}`;
              }
              messageList.push(newMessage);
            } else if (msg.type == "emoji") {
              let newMessage = {
                author:
                  msg.username == this.user.username ? "me" : msg.username,
                data: { emoji: msg.content, meta: msg.time },
                type: msg.type,
              };
              messageList.push(newMessage);
            } else if (msg.type == "audio call" && msg.content) {
              let newMessage = {
                author:
                  msg.username == this.user.username ? "me" : msg.username,
                data: {
                  text: msg.status,
                  meta: { time: msg.time, icon: "fas fa-phone-alt" },
                },
                type: "system",
              };
              if (msg.status == "audio call initiated") {
                newMessage.data.text = `Call initiated ${msg.firstName} ${msg.lastName}`;
              }
              messageList.push(newMessage);
            } else if (msg.patientExitMessage) {
              let newMessage = {
                author: msg.username,
                data: { text: msg.content, meta: msg.time },
                type: msg.type,
              };
              messageList.push(newMessage);
            } else if (
              msg.doctorJoinedMessage ||
              msg.doctorExitedMessage ||
              msg.prescriptionSharedMessage
            ) {
              if (this.IS_CARECO || this.IS_NURSE) {
                let newMessage = {
                  author: msg.username,
                  data: { text: msg.content, meta: msg.time },
                  type: msg.type,
                };
                messageList.push(newMessage);
              }
            } else if (
              (msg.carecoJoinedMessage || msg.carecoExitedMessage) &&
              this.IS_NURSE
            ) {
              let newMessage = {
                author: msg.username,
                data: { text: msg.content, meta: msg.time },
                type: msg.type,
              };
              messageList.push(newMessage);
            }
          }
        }
      }
      return messageList;
    },
    onGoingCall() {
      for (let i = this.appointmentMessages.length - 1; i >= 0; i--) {
        if (
          this.appointmentMessages[i].content &&
          this.appointmentMessages[i].content == "Video call"
        ) {
          if (this.appointmentMessages[i].status == "accepted") {
            if (
              this.IS_CARECO &&
              this.appointmentMessages[i].username != this.user.username
            ) {
              return true;
            }
            if (
              this.IS_DOCTOR &&
              this.appointmentMessages[i].username != this.user.username &&
              this.remoteUser &&
              this.appointmentMessages[i].username != this.remoteUser.id
            ) {
              return true;
            }
            return false;
          } else {
            return false;
          }
        }
      }
    },
    HAS_VITALS() {
      let HAS_VITALS = false;
      if (this.appointmentForCurrentPatient) {
        //Check for empty vitals
        for (var vital in this.appointmentForCurrentPatient.vitals) {
          if (
            this.appointmentForCurrentPatient.vitals[vital].value == "--" ||
            this.appointmentForCurrentPatient.vitals[vital].value == ""
          ) {
            HAS_VITALS = false;
          } else {
            HAS_VITALS = true;
            break;
          }
        }
      }
      return HAS_VITALS;
    },
    HAS_PRESCRIPTION() {
      let prescriptions = this.prescription.prescriptions;
      return PrescriptionService.hasPrescription(prescriptions);
    },
    HAS_ATTACHMENTS() {
      let prescriptions = this.prescription.prescriptions;
      return prescriptions.attachments && prescriptions.attachments.length;
    },
    previewLink() {
      return this.baseUrl + "/file/";
    },

    // for prescription preview
    patientDOB() {
      var m = moment(this.appointment.patient.dob);
      var years = moment().diff(m, "years", false);
      var months = moment().diff(m.add(years, "years"), "months", false);
      return (
        years +
        " " +
        this.$t("message.Years") +
        " " +
        months +
        " " +
        this.$t("message.Months")
      );
    },
    doctAppointmentDate() {
      return moment(
        this.appointment.appointmentDate
          ? this.appointment.appointmentDate.date
          : this.appointment.createdTimestamp
      ).format("DD-MM-YYYY");
    },
    floatingVideoPositionTop() {
      return window.innerHeight - 264;
    },
  },

  methods: {
    // update floating window parent height and window position.
    resizeWindowEventHandler() {
      // condition check because video-call tab creating some problem.
      if (this.activeTab !== "video-call") {
        const mainTab = this.$refs.mainTab;
        this.parentHeight = mainTab.$el.offsetHeight;
        this.parentWidth = mainTab.$el.offsetWidth;
        setTimeout(() => {
          this.floatingVideoPositionX = 0;
          this.floatingVideoPositionY = this.parentHeight - 246;
        }, 100);
      }
    },
    calculateDob() {
      if (this.ageUnit == "years") {
        this.patientAgeMonths = null;
        this.patientAgeYears = this.patientAge;
      }

      if (this.ageUnit == "months") {
        this.patientAgeYears = null;
        this.patientAgeMonths = this.patientAge;
      }

      let currentYear = new Date().getUTCFullYear();
      let yearOFBirth = currentYear - (this.patientAgeYears || 0);

      let currentMonth = new Date().getMonth() + 1;
      let monthOfBirth = currentMonth - (this.patientAgeMonths || 0);

      if (monthOfBirth == 0 || Math.sign(monthOfBirth) == -1) {
        --yearOFBirth;
        monthOfBirth = 12 + monthOfBirth;
      }
      this.patientForDiscussion.dob = monthOfBirth + "/01/" + yearOFBirth;
    },
    async initSocketHandlers() {
      let that = this;

      socket.on("appointmentDeclined", async function () {
        swal.fire({
          title: that.$t("message.Appointment Update"),
          text: that.$t("message.Sorry! Your appointment was declined"),
          type: "warning",
          timer: 4000,
        });
        that.$router.push("nursehome");
      });

      socket.on("appointmentExit", async function (data) {
        if (that.appointment._id == data.appointmentId) {
          //End VC
          /*         if (that.$refs["webex-teams"]) {
            that.endWebexCall();
          } else if (that.$refs.vmaatu) {
            that.$refs.vmaatu.destroy();
          } */

          let text = "";
          if (data.user == "nurse") {
            text = that.$t("message.Nurse exited");
          } else if (data.user == "patient") {
            text = that.$t("message.Patient exited");
          } else {
            text = that.$t("message.Doctor exited");
          }

          if (that.IS_CARECO) {
            text =
              "Dr. " +
              that.appointment.provider.firstName +
              " " +
              that.appointment.provider.lastName +
              "has ended the video consultation.";
          }
          swal.fire({
            title: that.$t("message.Appointment Update"),
            text: text,
            timer: 4000,
            type: "success",
          });

          if (that.IS_CARECO || that.IS_NURSE) {
            let response = await that.$store.dispatch(
              "getAppointment",
              that.appointment._id
            );
            if (response && response._id) {
              await that.$store.commit("setState", {
                stateName: "appointment",
                stateValue: response,
              });
            }
            that.disableInput = true;
            if (that.$refs.vmaatu) {
              that.$refs.vmaatu.destroy();
            }
            that.showVideo = false;
            that.showVideoCall = false;
            that.goToChatMessage();
          }
        }
      });

      socket.on("appointmentJoined", async (data) => {
        //Ignoring event from me && event with endpoint id in data
        let that = this;
        if (this.user._id != data.userId) {
          //If appointment is  for speciality or message is from primary provider
          if (
            !this.appointment.provider.providerId ||
            data.userId == this.appointment.provider.providerId
          ) {
            this.prescription.providerId =
              this.appointment.provider.providerId || data.userId;

            await this.$store.dispatch("getAppointment", this.appointment._id);

            //Generate room url for Webex endpoints
            if (
              that.user.endpoint.videoConfEPType == "SPARK_EMBEDDED" ||
              that.user.endpoint.videoConfEPType == "WEBEXTEAMS_GUEST"
            ) {
              let webexTokens = await that.$store.dispatch(
                "getValidWebexGuestAccessToken"
              );

              if (webexTokens) {
                that.simpleMeetingsQuery = {
                  api_key: that.settings.vMaatuSettings.apikey,
                  room_name:
                    that.instance + "_" + that.appointment._id + "_doctor",
                  user_name: that.user.username,
                  tenant_name: that.user.tenant.name,
                  access_token: webexTokens.accessToken,
                  destination: that.appointment.webexTeams.roomId,
                };
              } else {
                localStorage.setItem("user", null);
                that.$router.push("signin");
              }
            }
            if (!this.IS_CARECO) {
              this.showVideoCall = true;
              this.callNotification = false;
              setTimeout(() => {
                that.$refs.vmaatu.init();
                console.log("vmaatu init");
              }, 1000);
              this.goToVideoCall();
              swal.fire({
                title: this.$t("message.Appointment Update"),
                text: this.$t("message.Doctor has joined the appointment"),
                timer: 4000,
                type: "info",
              });
            }
          }
        }
      });

      socket.on("appointmentPatientUpdate", async (data) => {
        console.log("recieved socket for patient update ...");
        if (data.userId != this.user._id) {
          let response = await this.$store.dispatch(
            "getAppointment",
            this.appointment._id
          );

          console.log("response from socket", response);

          if (response && response.appointmentForCurrentPatient) {
            console.log("setting appointmentForCurrentPatient ");
            this.appointmentForCurrentPatient = await this.$store.dispatch(
              "getAppointmentById",
              response.appointmentForCurrentPatient
            );
            response.patient = this.appointmentForCurrentPatient.patient;
          }

          console.log(
            "set appointmentForCurrentPatient :",
            this.appointmentForCurrentPatient
          );

          await this.$store.commit("setState", {
            stateName: "appointment",
            stateValue: response,
          });
          if (
            response.appointmentForCurrentPatient &&
            this.appointmentForCurrentPatient.patient &&
            this.appointmentForCurrentPatient.patient.patientId
          ) {
            console.log("showing swal ....");
            // add swal for added patient
            swal.fire({
              title: this.$t("message.Appointment Update"),
              text: this.$t("message.Patient added to appointment"),
              timer: 3000,
              type: "info",
            });
            this.patient = this.appointmentForCurrentPatient.patient;
          } else {
            console.log("removing patient details on socket update");

            this.resetPatientDetailsForAppointment();

            // add swal for patient removed
            swal.fire({
              title: this.$t("message.Appointment Update"),
              text: this.$t("message.Patient removed from appointment"),
              timer: 3000,
              type: "info",
            });
          }

          await this.getHistoricPatientData();
        }
      });

      socket.on("filesUpdate", (data) => {
        //Added !data.userId as there is no user id coming from UploadFile from direct telemed app
        if (!data.userId || data.userId != this.user._id) {
          this.$refs["file-share-alert"].$el.style.display = "inline-block";
          this.getFiles();
        }
      });

      socket.on("vitalsUpdate", async (data) => {
        if (data.userId != that.user._id) {
          let appointment = await that.$store.dispatch(
            "getAppointmentById",
            that.appointmentForCurrentPatient._id
          );
          that.appointmentForCurrentPatient.vitals = appointment.vitals;
          that.appointmentForCurrentPatient.__v = appointment.__v;

          for (var vitalName in that.appointmentForCurrentPatient.vitals) {
            let vital = that.appointmentForCurrentPatient.vitals[vitalName];
            this.deviceProfile.forEach((device) => {
              device.vitals.forEach((deviceVital) => {
                if (deviceVital.identifier == vitalName) {
                  this.$set(deviceVital, "value", vital.value);
                }
              });
              if (device.vitalsGroup) {
                device.vitalsGroup.forEach((group) => {
                  if (group.vitals) {
                    group.vitals.forEach((vital) => {
                      if (deviceVital.identifier == vitalName) {
                        this.$set(deviceVital, "value", vital.value);
                      }
                    });
                  }
                });
              }
            });
          }
          this.$refs["vital-share-alert"].$el.style.display = "inline-block";
          this.getVitalHistory();
        }
      });

      socket.on("prescriptionsUpdate", async function (data) {
        if (data.userId != that.user._id) {
          //New prescription notify badge display
          that.$refs["prescription-share-alert"].$el.style.display =
            "inline-block";
          //Get prescriptions
          let prescriptions = await that.$store.dispatch(
            "getPrescriptions",
            that.appointmentForCurrentPatient._id
          );

          if (prescriptions && prescriptions.length > 0) {
            that.prescription = prescriptions[0];
            // this.prescriptionAlert = true;
          }

          // $("#third-tab #signatureImg").attr(
          //   "src",
          //   "/file/" + this.prescription.prescriptions.signature
          // );

          // $timeout(function () {
          //   if ($("#prescription-tab").hasClass("active")) {
          //     this.prescriptionAlert = false;
          //   }
          // }, 2000);
        }
      });

      socket.on("appointmentPostponed", async (data) => {
        console.log(data);
        console.log(this.user._id);
        if (this.IS_NURSE) {
          swal.fire({
            title: this.$t("message.Appointment Update"),
            text: this.$t(
              "message.Doctor has postponed the prescription for this appointment"
            ),
            timer: 4000,
            type: "info",
          });
          let response = await this.$store.dispatch(
            "getAppointment",
            this.appointment._id
          );
          console.log("response", response);

          if (response && response._id) {
            await that.$store.commit("setState", {
              stateName: "appointment",
              stateValue: response,
            });
          }
          this.resetPatientDetailsForAppointment();
          that.disableInput = true;
          that.showVideo = false;
          that.goToChatMessage();
        }
      });
      socket.on("newChatMessage", async (message) => {
        console.log(message);
        if (message.chatMessage.username != that.user.username) {
          if (message.chatMessage.to == that.user.username) {
            if (
              message.chatMessage.status &&
              message.chatMessage.status == "initiated"
            ) {
              for (let participant of this.participants) {
                if (participant.id == message.chatMessage.username) {
                  this.remoteUser = participant;
                }
              }
              this.callType = "incoming";
              this.caller.img = this.remoteUser.imageUrl || this.defaultImage;
              this.caller.name =
                message.chatMessage.username ==
                this.appointment.provider.username
                  ? "Dr. " + this.remoteUser.name
                  : this.remoteUser.name;
              this.callNotification = true;
            } else if (
              message.chatMessage.status &&
              message.chatMessage.status == "accepted"
            ) {
              let that = this;
              this.callNotification = false;
              this.showVideo = true;
              this.goToVideoCall();
              this.hideVmaatuControls = false;
              setTimeout(() => {
                that.$refs.vmaatu.init();
                console.log("vmaatu init");
              }, 1000);
            } else if (
              message.chatMessage.status &&
              message.chatMessage.status == "declined"
            ) {
              this.callNotification = false;
            } else if (
              message.chatMessage.status &&
              message.chatMessage.status == "ended"
            ) {
              if (this.$refs.vmaatu) {
                this.$refs.vmaatu.destroy();
              }
              this.showVideo = false;
              this.goToChatMessage();
            } else if (
              message.chatMessage.status &&
              message.chatMessage.status == "cancelled"
            ) {
              this.callNotification = false;
            } else if (
              message.chatMessage.status &&
              message.chatMessage.status == "missed"
            ) {
              this.callNotification = false;
            }
          }

          if (message.chatMessage.patientExitMessage) {
            this.disableInput = true;
            if (this.$refs.vmaatu) {
              this.$refs.vmaatu.destroy();
            }
            this.showVideo = false;
            this.goToChatMessage();
          }

          let response = await that.$store.dispatch(
            "getAppointment",
            that.appointment._id
          );
          console.log(response);
          if (response && response._id) {
            await that.$store.commit("setState", {
              stateName: "appointment",
              stateValue: response,
            });
          }
          //Get Appointment messages
          if (this.appointment) {
            let response = await this.$store.dispatch(
              "getAppointmentMessages",
              this.appointment._id
            );
            this.appointmentMessages = response;
          }
          this.$forceUpdate();
        }
      });
      socket.on("chatTyping", function (data) {
        if (data.typing && data.userId != that.user.username) {
          that.showTypingIndicator = data.userId;
        }
        if (!data.typing) {
          that.showTypingIndicator = "";
        }
      });
    },
    async initiatePatientCreation() {
      if (this.settings.autoDebitCreditsForDiscussionEnabled) {
        let creditsAvailable = await this.checkNurseCreditPoints();
        if (!creditsAvailable) {
          swal.fire({
            title: this.$t("message.Nurse has insufficient credit balance"),
            timer: 2000,
            type: "warning",
          });
          return;
        }
      }
      this.SHOW_PATIENT_CREATION_MODAL = true;
    },
    async checkNurseCreditPoints() {
      let nurse = await this.$store.dispatch(
        "getUserById",
        this.appointment.user
      );
      let minLimit = 0;
      if (
        this.settings.customCreditsLimit &&
        this.settings.customCreditsLimit.enabled &&
        this.settings.customCreditsLimit.discussion.enabled
      ) {
        minLimit = this.settings.customCreditsLimit.minLimit;
      }
      if (nurse.credits > minLimit) {
        return true;
      } else {
        return false;
      }
    },
    async validatePatientDetails() {
      this.$validator.validateAll().then(async (isValid) => {
        if (isValid) {
          let loader = this.$loading.show();
          try {
            let patient = await this.$store.dispatch(
              "createPatient",
              this.patientForDiscussion
            );

            await this.createNewAppointmentForPatient(patient);

            this.appointment.patient =
              this.appointmentForCurrentPatient.patient;
            this.patient = this.appointment.patient;
            this.createPatientBtnFixed = false;

            loader.hide();

            swal.fire({
              type: "success",
              title: this.$t(
                "message.Patient added to the appointment successfully"
              ),
              timer: 3000,
            });
            this.PATIENT_SELECTED = true;
            this.SHOW_PATIENT_CREATION_MODAL = false;
          } catch (e) {
            loader.hide();
            console.log(e);
            swal.fire({
              type: "error",
              title: this.$t("message.Could not add the patient"),
              timer: 3000,
            });
          }
        }
      });
    },

    resetPatientDetailsForAppointment() {
      this.patient = null;
      this.appointment.patient = {};

      this.patientProfileImage = null;
      this.patientAgeMonths = null;
      this.patientAgeYears = null;
      this.patientAge = null;
      this.mobileNumber = null;

      this.PATIENT_SELECTED = false;
      this.NEW_PATIENT = false;

      // reset files
      this.files = [];

      // reset prescription
      if (this.HAS_PRESCRIPTION) {
        this.prescription = {
          prescriptions: {
            attachments: [],
            descriptiveNotes: null,
            provisionalDiagnosis: {
              notes: null,
              icdCodes: [],
            },
            rx: [],
            labPrescription: [],
            followup: {
              requested: false,
            },
            imagingPrescription: { types: [] },
          },
        };
      }
      if (this.appointmentForCurrentPatient) {
        localStorage.removeItem(
          "prescription" + this.appointmentForCurrentPatient._id
        );
      }
      this.appointmentForCurrentPatient = null;

      // reset vitals
      // this.historicVitals = null;
      this.deviceProfile.forEach((device) => {
        device.vitals.forEach((vital) => {
          this.$set(this.errorMessages, vital.identifier, []);

          //Setting device vitals values to null
          vital.value = null;
        });
      });
    },

    async removeCurrentPatient() {
      try {
        await this.endAppointmentForCurrentPatient();

        this.resetPatientDetailsForAppointment();

        await this.$store.dispatch("removeAppointmentReferenceFromDiscussion", {
          discussionId: this.appointment._id,
        });

        socket.emit("appointmentPatientUpdate", {
          appointmentId: this.appointment._id,
          userId: this.user._id,
        });
      } catch (error) {
        console.error(error);
      }
    },

    resetPatientSelection() {
      swal
        .fire({
          title: this.$t("message.Are you sure?"),
          text: "The patient will be removed",
          confirmButtonText: this.$t("message.Yes"),
          showCancelButton: true,
          cancelButtonText: this.$t("message.No"),
        })
        .then(async (result) => {
          if (result && result.value) {
            await this.removeCurrentPatient();
          }
        });
    },

    async searchPatients(searchString) {
      try {
        if (searchString.length > 2) {
          this.patients = await this.$store.dispatch("searchPatients", {
            query: searchString,
            pageSize: 20,
          });
          if (this.patients.length > 0) {
            this.createPatientBtnFixed = true;
          }
        } else {
          this.patients = [];
          this.createPatientBtnFixed = false;
        }
      } catch (e) {
        console.log(e);
      }
    },

    mobileNumberUpdate(payload) {
      this.isValidMobile = payload.isValid;
      this.patientForDiscussion.mobileNumber = payload.formattedNumber;
    },

    async selectPatient(patient) {
      this.patients = [];
      this.patientSearchText = "";

      if (this.settings.autoDebitCreditsForDiscussionEnabled) {
        let creditsAvailable = await this.checkNurseCreditPoints();
        if (!creditsAvailable) {
          swal.fire({
            title: this.$t("message.Nurse has insufficient credit balance"),
            timer: 2000,
            type: "warning",
          });
          return;
        }
      }

      // this.appointment.patient = appointment.patient;
      this.patient = patient;
      await this.createNewAppointmentForPatient(patient);

      if (patient.profileImage) {
        this.patientProfileImage = patient.profileImage;
      }

      this.appointment.patient.mobileNumber = "";
      this.appointment.patient.patientId = patient.patientId;
      this.appointment.patient.firstName = patient.firstName;
      this.appointment.patient.lastName = patient.lastName;

      var m = moment(this.appointment.patient.dob);
      var years = moment().diff(m, "years", false);
      this.patientAge = years;
      m = moment(m).add(years, "years");
      var months = moment().diff(m, "months", false);
      this.patientAgeMonths = months;

      if (this.patientAgeYears < 1) {
        this.ageUnit = "months";
        this.patientAge = months;
      } else {
        this.ageUnit = "years";
        this.patientAge = years;
      }

      this.appointment.patient.gender = patient.gender;
      this.appointment.patient.history = patient.history;
      this.appointment.patient.email = patient.email;
      this.appointment.patient.mobileNumber =
        patient.mobileNumber && patient.mobileNumber.replace(/ /g, "");

      if (this.appointment.patient.mobileNumber) {
        this.mobileNumber = this.appointment.patient.mobileNumber;
      }

      this.appointment.patient.additionalInfo = patient.additionalDetails
        ? patient.additionalDetails
        : {};
      this.appointment.patient.provider = patient.provider;

      this.addPatientEnable = false;
      if (this.error) this.error = "";
      this.PATIENT_SELECTED = true;
      this.createPatientBtnFixed = false;

      await this.getHistoricPatientData();

      swal.fire({
        type: "success",
        title: this.$t("message.Patient added to the appointment successfully"),
        timer: 3000,
      });
    },

    async getHistoricPatientData() {
      //Get patient details
      try {
        if (
          this.appointmentForCurrentPatient &&
          this.appointmentForCurrentPatient.patient.patientId
        ) {
          this.patient = await this.$store.dispatch(
            "getPatientByPatientId",
            this.appointmentForCurrentPatient.patient.patientId
          );
        } else if (this.appointmentForCurrentPatient.patient.firstName) {
          this.patient = this.appointmentForCurrentPatient.patient;
        }
      } catch (e) {
        console.log(e);
      }

      // get lab orders by patient
      if (this.patient && this.appointmentForCurrentPatient) {
        this.patientLaborders = await this.$store.dispatch(
          "getLabordersByPatient",
          { patientId: this.appointmentForCurrentPatient.patient.patientId }
        );
      }

      //Get patient ID file
      if (
        this.appointment.consultationType == "telemed-direct" &&
        !this.patientIdFile
      ) {
        var query = {
          appointmentId: this.appointment._id,
          kind: "PatientID",
        };

        this.patientIdFile = (
          await this.$store.dispatch("getFiles", {
            query,
          })
        ).data[0];
      }

      //Get files history
      try {
        this.historicFiles = (
          await this.$store.dispatch(
            "getFilesHistory",
            this.appointmentForCurrentPatient.patient.patientId
          )
        ).data;
      } catch (e) {
        console.log(e);
      }

      //Get prescription history
      try {
        this.historicPrescriptions = (
          await this.$store.dispatch("getPrescriptionsHistory", {
            patientId: this.appointmentForCurrentPatient.patient.patientId,
          })
        ).data;
      } catch (e) {
        console.log(e);
      }

      //Get prescriptions
      let prescriptions = null;
      if (this.appointmentForCurrentPatient) {
        prescriptions = await this.$store.dispatch(
          "getPrescriptions",
          this.appointmentForCurrentPatient._id
        );

        if (prescriptions && prescriptions.length > 0) {
          this.PRESCRIPTION_SHARED = true;
          this.prescription = prescriptions[0];
        } else {
          this.prescription.patientId =
            this.appointmentForCurrentPatient.patient.patientId;
          this.prescription.providerId =
            this.appointment.provider &&
            this.appointmentForCurrentPatient.provider.providerId;
          this.prescription.appointmentId =
            this.appointmentForCurrentPatient._id;
        }
      }
    },

    async createNewAppointmentForPatient(patient) {
      // creating regular appointment from discussion apt
      let newAppointment = { discussionAppointmentId: this.appointment._id };
      newAppointment = Object.assign(newAppointment, this.appointment);
      delete newAppointment._id;
      delete newAppointment.created;
      newAppointment.appointmentType = "Live";

      // setting patient detials
      newAppointment.patient.mobileNumber = "";
      newAppointment.patient.patientId = patient.patientId;
      newAppointment.patient.firstName = patient.firstName;
      newAppointment.patient.lastName = patient.lastName;

      newAppointment.patient.gender = patient.gender;
      newAppointment.patient.history = patient.history;
      newAppointment.patient.email = patient.email;
      newAppointment.patient.mobileNumber =
        patient.mobileNumber && patient.mobileNumber.replace(/ /g, "");

      if (newAppointment.patient.mobileNumber) {
        this.mobileNumber = newAppointment.patient.mobileNumber;
      }

      newAppointment.patient.additionalInfo = patient.additionalDetails
        ? patient.additionalDetails
        : {};
      newAppointment.patient.provider = patient.provider;
      newAppointment.patient.dob = patient.dob;

      newAppointment.appointmentStatus = [
        {
          status: "InProgress",
          timestamp: new Date().getTime(),
        },
      ];
      newAppointment.latestStatus = "InProgress";

      this.appointmentForCurrentPatient = await this.$store.dispatch(
        "createAppointment",
        newAppointment
      );
      await this.$store.dispatch("saveAppointmentReferenceToDiscussion", {
        discussionId: this.appointment._id,
        appointmentId: this.appointmentForCurrentPatient._id,
      });

      socket.emit("appointmentPatientUpdate", {
        appointmentId: this.appointment._id,
        userId: this.user._id,
      });
    },

    async endAppointmentForCurrentPatient() {
      if (this.appointmentForCurrentPatient) {
        let aptStatus = this.IS_DOCTOR ? "Completed" : "Closed";

        await this.$store.dispatch("updateStatus", {
          appointmentId: this.appointmentForCurrentPatient._id,
          status: aptStatus,
        });

        this.appointmentForCurrentPatient = null;
      }
    },

    closeCaptureModal() {
      if (this.$refs.vmaatu) {
        this.$refs.vmaatu.initSimplemeetings();
      }

      this.SHOW_CAPTURE_MODAL = false;
    },
    async saveImage(fileData) {
      let _this = this;

      const { value: fileName } = await swal.fire({
        title: _this.$t("message.Enter file name"),
        input: "text",
        inputValue: "Untitled.png",
        showCancelButton: true,
        inputValidator: (value) => {
          return !value && "Please Enter filename!";
        },
      });

      if (fileName) {
        let fileBlob = _this.dataURItoBlob(fileData);
        let fileToSave = {
          name: fileName.endsWith(".png") ? fileName : fileName + ".png",
          data: fileBlob,
          type: "image/png",
          size: fileBlob.size,
        };
        _this.saveFile(fileToSave);
      }
    },

    closePrescriptionCaptureModal() {
      if (this.$refs.vmaatu) {
        this.$refs.vmaatu.initSimplemeetings();
      }

      this.$refs.prescriptionDetails.SHOW_CAPTURE_MODAL = false;
    },

    async openCameraForPrescriptionAttachment() {
      if (this.$refs.vmaatu) {
        this.$refs.vmaatu.destroy();
        this.$refs.vmaatu.simpleMeetingsVmaatu = null;
      }
      this.$refs.prescriptionDetails.openCameraModalForFileUpload();
    },

    openCameraModalForFileUpload() {
      if (this.$refs.vmaatu) {
        this.$refs.vmaatu.destroy();
        this.$refs.vmaatu.simpleMeetingsVmaatu = null;
      }

      setTimeout(() => {
        this.SHOW_CAPTURE_MODAL = true;
        this.$refs.camera.createCameraElement();
      }, 1000);
    },
    sendMessage(text) {
      console.log(text);
      if (text.length > 0) {
        this.newMessagesCount = this.isChatOpen
          ? this.newMessagesCount
          : this.newMessagesCount + 1;
        this.onMessageWasSent({
          author: "me",
          type: "text",
          data: { text },
        });
      }
    },
    async onMessageWasSent(message) {
      socket.emit("chatTyping", {
        appointmentId: this.appointment._id,
        userId: this.user.username,
        typing: false,
      });
      let that = this;
      if (message.type == "text" || message.type == "system") {
        let msg = {
          username: this.user.username,
          name: `${this.user.firstName} ${this.user.lastName}`,
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          content: message.data.text,
          time: moment().format("DD-MM-YYYY, h:mm a"),
          type: message.type,
        };
        this.updateMessages(msg);
      } else if (message.type == "file") {
        that.CHAT_FILE_UPLOADING = true;
        let msg = {
          username: this.user.username,
          name: `${this.user.firstName} ${this.user.lastName}`,
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          content: message.data.file.name,
          fileId: "",
          text: "",
          time: moment().format("DD-MM-YYYY, h:mm a"),
          type: message.type,
          fileType: message.data.file.type,
        };
        if (message.data.text) {
          msg.text = message.data.text;
        }
        console.log(message.data.file);

        this.retrievePresignedUrl(
          message.data.file,
          async function (url, fileId, file) {
            let res = await that.uploadChatFile(file, url, fileId);
            if (res && res.fileId) {
              msg.fileId = res.fileId;
              that.updateMessages(msg);
            }
            that.CHAT_FILE_UPLOADING = false;
          }
        );
      } else if (message.type == "emoji") {
        let msg = {
          username: this.user.username,
          name: `${this.user.firstName} ${this.user.lastName}`,
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          content: message.data.emoji,
          time: moment().format("DD-MM-YYYY, h:mm a"),
          type: message.type,
        };
        this.updateMessages(msg);
      }
    },
    messageAvatar(id) {
      for (let participant of this.participants) {
        if (participant.id == id) {
          return participant.imageUrl;
        }
      }
      return this.defaultImage;
    },
    //Getting src for send file preview
    getFileSrc(file) {
      let fileSrc = URL.createObjectURL(file);
      return fileSrc;
    },
    async onCallDeclined() {
      this.callNotification = false;

      let response = await this.$store.dispatch("updateCallStatus", {
        appointmentId: this.appointment._id,
        status: "declined",
      });

      if (response && response._id) {
        //Get appointment messages
        if (this.appointment) {
          let response = await this.$store.dispatch(
            "getAppointmentMessages",
            this.appointment._id
          );
          this.appointmentMessages = response;
        }

        let message = {
          username: this.user.username,
          status: "declined",
          to: this.remoteUser.id,
        };
        socket.emit("newChatMessage", {
          appointmentId: this.appointment._id,
          chatMessage: message,
        });
      }
    },
    async onCallAccepted() {
      let that = this;
      this.callNotification = false;
      this.showVideo = true;

      let response = await this.$store.dispatch("updateCallStatus", {
        appointmentId: this.appointment._id,
        status: "accepted",
      });

      if (response && response._id) {
        //Get appointment messages
        if (this.appointment) {
          let response = await this.$store.dispatch(
            "getAppointmentMessages",
            this.appointment._id
          );
          this.appointmentMessages = response;
        }

        setTimeout(() => {
          that.$refs.vmaatu.init();
          console.log("vmaatu init");
        }, 1000);
        this.goToVideoCall();
        this.hideVmaatuControls = false;
        let message = {
          username: this.user.username,
          status: "accepted",
          to: this.remoteUser.id,
        };
        socket.emit("newChatMessage", {
          appointmentId: this.appointment._id,
          chatMessage: message,
        });
      }
    },
    async onCallMissed() {
      this.callNotification = false;
      if (this.outGoingCall == true) {
        this.outGoingCall = false;

        let response = await this.$store.dispatch("updateCallStatus", {
          appointmentId: this.appointment._id,
          status: "missed",
        });

        if (response && response._id) {
          //Get appointment messages
          if (this.appointment) {
            let response = await this.$store.dispatch(
              "getAppointmentMessages",
              this.appointment._id
            );
            this.appointmentMessages = response;
          }

          let message = {
            username: this.user.username,
            status: "missed",
            to: this.remoteUser.id,
          };
          socket.emit("newChatMessage", {
            appointmentId: this.appointment._id,
            chatMessage: message,
          });
          this.$forceUpdate();
        }
      }
    },
    showPreview(file) {
      this.previewFile = file;
      this.showPreviewModal = true;
    },
    async makeVideoCall() {
      this.callType = "outgoing";
      this.callNotification = true;
      this.outGoingCall = true;
      await this.$store.dispatch("notifyAppointment", {
        appointmentId: this.appointment._id,
        patientOnly: false,
      });
      /*       let response = await this.$store.dispatch(
        "getAppointment",
        this.appointment._id
      );
      await this.$store.commit("setState", {
        stateName: "appointment",
        stateValue: response,
      });
      if (["Closed"].includes(this.appointment.latestStatus)) {
        swal.fire({
          title: "Error",
          text: this.$t("message.Unable to start video call, patient has exited!"),
          type: "error",
          timer: 5000,
        });
      } else if (
        ["Completed", "Postponed"].includes(this.appointment.latestStatus)
      ) {
        swal.fire({
          title: "Error",
          text: this.$t("message.Unable to start video call, doctor has ended the video consultation!"),
          type: "error",
          timer: 5000,
        });
      } else {
        let text = "";
        if (this.IS_DOCTOR) {
          if (this.appointment.consultationType != "telemed-direct") {
            for (let participant of this.participants) {
              if (participant.id == this.nurse.username) {
                this.remoteUser = participant;
              }
            }
            text = this.$t("message.Unable to start video call, nurse is busy!");
          } else {
            for (let participant of this.participants) {
              if (participant.id == this.appointment.patient.patientId) {
                this.remoteUser = participant;
              }
            }
            text = this.$t("message.Unable to start video call, patient is busy!");
          }
        } else if (this.IS_NURSE) {
          for (let participant of this.participants) {
            if (participant.id == this.appointment.provider.username) {
              this.remoteUser = participant;
            }
          }
          text = this.$t("message.Unable to start video call, doctor is busy!");
        } else if (this.IS_CARECO) {
          if (this.appointment.consultationType == "telemed-direct") {
            for (let participant of this.participants) {
              if (participant.id == this.appointment.patient.patientId) {
                this.remoteUser = participant;
              }
            }
            text = this.$t("message.Unable to start video call, patient is busy!");
          } else {
            for (let participant of this.participants) {
              if (participant.id == this.nurse.username) {
                this.remoteUser = participant;
              }
            }
            text = this.$t("message.Unable to start video call, nurse is busy!");
          }
        }
        for (let i = this.appointmentMessages.length - 1; i >= 0; i--) {
          if (
            this.appointmentMessages[i].content &&
            this.appointmentMessages[i].content == "Video call"
          ) {
            if (
              this.appointmentMessages[i].status == "initiated" ||
              this.appointmentMessages[i].status == "accepted"
            ) {
              swal.fire({
                title: "Error",
                text: text,
                type: "error",
                timer: 5000,
              });
              return;
            }
            break;
          }
        }
        if (this.remoteUser.id == this.appointment.provider.username) {
          this.provider = await this.$store.dispatch(
            "getUserById",
            this.appointment.provider.providerId
          );
          if (
            this.provider.status == "online" ||
            this.provider.status == "offline" ||
            (this.appointment.latestStatus == "InProgress" &&
              this.provider.status == "inAppointment" &&
              this.provider.currentAppointment == this.appointment._id)
          ) {
            this.initiateVideoCall();
          } else {
            swal.fire({
              title: "Error",
              text: this.$t("message.Unable to start video call, doctor is busy!"),
              type: "error",
              timer: 5000,
            });
          }
        } else if (
          this.nurse &&
          this.nurse.username &&
          this.remoteUser.id == this.nurse.username
        ) {
          this.nurse = await this.$store.dispatch(
            "getUserById",
            this.appointment.user
          );
          if (
            this.nurse.status == "online" ||
            this.nurse.status == "offline" ||
            (this.appointment.latestStatus == "InProgress" &&
              this.nurse.status == "inAppointment" &&
              this.nurse.currentAppointment == this.appointment._id)
          ) {
            this.initiateVideoCall();
          } else {
            swal.fire({
              title: "Error",
              text: this.$t("message.Unable to start video call, nurse is busy!"),
              type: "error",
              timer: 5000,
            });
          }
        } else {
          this.initiateVideoCall();
        }
      } */
    },
    initiateVideoCall() {
      let message = {
        username: this.user.username,
        name: `${this.user.firstName} ${this.user.lastName}`,
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        content: "Video call",
        time: moment().format("DD-MM-YYYY, h:mm a"),
        type: "call",
        status: "initiated",
        to: this.remoteUser.id,
      };
      this.updateMessages(message);

      this.caller.img = this.remoteUser.imageUrl || this.defaultImage;
      this.caller.name =
        this.remoteUser.name == this.appointment.provider.username
          ? "Dr. " + this.remoteUser.name
          : this.remoteUser.name;
      this.callType = "outgoing";
      this.callNotification = true;
      this.outGoingCall = true;
    },
    async sendDoctorJoinedMessage() {
      let content =
        this.$t("message.Doctor") + " " + this.$t("message.entered the chat");
      let newMessage = {
        username: this.appointment.provider.username,
        name: `${this.appointment.provider.firstName} ${this.appointment.provider.lastName}`,
        content: content,
        time: moment().format("DD-MM-YYYY, h:mm a"),
        type: "system",
        doctorJoinedMessage: true,
      };
      this.updateMessages(newMessage);
    },
    async sendAssistantJoinedMessage() {
      let content = "";
      if (
        this.settings &&
        this.settings.terminologies &&
        this.settings.terminologies.assistantLabel
      ) {
        content =
          this.settings.terminologies.assistantLabel[this.$i18n.locale] +
          " " +
          this.$t("message.entered the chat");
      }

      let newMessage = {
        username: this.user.username,
        name: `${this.user.firstName} ${this.user.lastName}`,
        content:
          content || this.$t("message.Doctor's assistant entered the chat"),
        time: moment().format("DD-MM-YYYY, h:mm a"),
        type: "system",
        carecoJoinedMessage: true,
      };
      this.updateMessages(newMessage);
    },
    openChat() {
      this.isChatOpen = true;
      this.newMessagesCount = 0;
    },
    closeChat() {
      this.isChatOpen = false;
    },
    handleOnType() {
      setTimeout(() => {
        let inputText = document.getElementsByClassName(
          "sc-user-input--text"
        )[0].innerText;
        let appointmentId = this.appointment._id;
        let userId = this.user.username;
        if (inputText.length > 0) {
          socket.emit("chatTyping", {
            appointmentId: appointmentId,
            userId: userId,
            typing: true,
          });
        } else {
          socket.emit("chatTyping", {
            appointmentId: appointmentId,
            userId: userId,
            typing: false,
          });
        }
      }, 1000);
    },
    async updateMessages(newMessage) {
      let response = await this.$store.dispatch("updateMessages", {
        appointmentId: this.appointment._id,
        newMesssage: newMessage,
      });
      if (response && response._id) {
        this.appointmentMessages.push(response.message);
        this.$forceUpdate();
        socket.emit("newChatMessage", {
          appointmentId: this.appointment._id,
          chatMessage: newMessage,
        });
      }
    },
    async endCall() {
      swal
        .fire({
          title: this.$t("message.Are you sure you want to end the call?"),
          confirmButtonText: this.$t("message.End call"),
          showCancelButton: true,
          cancelButtonText: this.$t("message.Stay"),
          confirmButtonColor: "#FF3636",
          cancelButtonColor: "#18ce0f",
        })
        .then(async (result) => {
          if (result && result.value) {
            if (this.$refs.vmaatu) {
              this.$refs.vmaatu.destroy();
            }
            this.showVideo = false;
            this.goToChatMessage();

            let response = await this.$store.dispatch("updateCallStatus", {
              appointmentId: this.appointment._id,
              status: "ended",
            });

            if (response && response._id) {
              //Get appointment messages
              if (this.appointment) {
                let response = await this.$store.dispatch(
                  "getAppointmentMessages",
                  this.appointment._id
                );
                this.appointmentMessages = response;
              }

              let message = {
                username: this.user.username,
                status: "ended",
                to: this.remoteUser.id,
              };
              socket.emit("newChatMessage", {
                appointmentId: this.appointment._id,
                chatMessage: message,
              });
            }
          }
        });
    },
    async onCallCancelled() {
      this.callNotification = false;

      let response = await this.$store.dispatch("updateCallStatus", {
        appointmentId: this.appointment._id,
        status: "cancelled",
      });

      if (response && response._id) {
        //Get appointment messages
        if (this.appointment) {
          let response = await this.$store.dispatch(
            "getAppointmentMessages",
            this.appointment._id
          );
          this.appointmentMessages = response;
        }

        let message = {
          username: this.user.username,
          status: "cancelled",
          to: this.remoteUser.id,
        };
        socket.emit("newChatMessage", {
          appointmentId: this.appointment._id,
          chatMessage: message,
        });
      }
    },
    async retrievePresignedUrl(file, cb) {
      let response = await this.$store.dispatch("getPresignedUrl", file.name);

      if (response) {
        cb(response.url, response.fileId, file);
      } else {
        this.UPLOADING = false;
        swal.fire({
          title: this.$t("message.File couldn't be shared!"),
          type: "error",
          timer: 5000,
        });
      }
    },
    async uploadChatFile(file, url, fileId) {
      var fileDetails = {
        name: file.name,
        type: file.type,
        size: file.size,
        fileId: fileId,
      };

      fileDetails.patientId = this.appointment.patient.patientId;
      fileDetails.appointmentId = this.appointment._id;

      //Save file to FileServer
      let response = await this.$store.dispatch("uploadChatFileToMinio", {
        url: url,
        file: file,
      });

      response = await this.$store.dispatch("uploadChatFile", fileDetails);

      if (response) {
        socket.emit("filesUpdate", {
          appointmentId: this.appointment._id,
          userId: this.user._id,
        });
        return response;
      }
    },
    async makeTelemedAudioCall() {
      let that = this;
      if (["Closed"].includes(this.appointment.latestStatus)) {
        swal.fire({
          title: "Error",
          text: that.$t(
            "message.Unable to initiate the call, patient has exited!"
          ),
          type: "error",
          timer: 5000,
        });
      } else if (["Completed"].includes(this.appointment.latestStatus)) {
        swal.fire({
          title: "Error",
          text: that.$t(
            "message.Unable to initiate the call, doctor has ended the video consultation!"
          ),
          type: "error",
          timer: 5000,
        });
      } else {
        swal
          .fire({
            title: that.$t("message.Phone call will be initiated"),
            type: "info",
            showCancelButton: true,
            cancelButtonText: that.$t("message.Cancel"),
          })
          .then(async (result) => {
            if (result && result.value) {
              let callDetails = {
                from: that.user.mobileNumber,
                to: that.appointment.patient.mobileNumber,
              };
              try {
                let res = await that.$store.dispatch(
                  "makeAudioCall",
                  callDetails
                );
                if (res) {
                  let message = {
                    username: that.user.username,
                    name: `${that.user.firstName} ${that.user.lastName}`,
                    firstName: that.user.firstName,
                    lastName: that.user.lastName,
                    content: "Audio call",
                    time: moment().format("DD-MM-YYYY, h:mm a"),
                    type: "audio call",
                    status: "audio call initiated",
                  };
                  that.updateMessages(message);
                  console.log(res);
                }
              } catch {
                swal.fire({
                  title: "Error",
                  text: that.$t("message.Unable to initiate call"),
                  type: "error",
                  timer: 5000,
                });
              }
            }
          });
      }
    },

    initSocket() {
      console.log("Telemed - initSocket");
      socket.emit("joinRoom", {
        type: "appointment",
        id: this.appointment._id,
        userId: this.user._id,
      });
    },
    onTabChange(label) {
      this.activeTab = label;
      this.changeAppHeaderText(label);
      console.log(label);

      if (
        this.activeTab == "patient-history" ||
        this.activeTab == "live-vitals"
      ) {
        this.getVitalHistory();
      }
      if (this.activeTab == "live-vitals") {
        this.$refs["vital-share-alert"].$el.style.display = "none";
      }
      if (this.activeTab == "file-share") {
        this.$refs["file-share-alert"].$el.style.display = "none";
      }
      if (this.activeTab == "prescription") {
        if (
          this.$refs["prescription-share-alert"] &&
          this.$refs["prescription-share-alert"].$el
        ) {
          this.$refs["prescription-share-alert"].$el.style.display = "none";
        }
      }
      if (this.$refs.vmaatu || this.$refs["webex-teams"]) {
        let endButton = document.getElementsByClassName("end-button");
        let localVideo = document.getElementsByClassName("my-video-div");
        let participantName =
          document.getElementsByClassName("participant-name");
        let meetingWindow = document.getElementById("meeting");
        let mainContent = document.getElementsByClassName("main-content");
        let loader = document.getElementsByClassName("el-loading-spinner");
        let floatingPtz = document.getElementsByClassName("floating-ptz");
        let zoomButtons = document.getElementsByClassName("zoom-buttons");
        if (this.activeTab == "video-call") {
          this.hideVmaatuControls = false;
          if (endButton && endButton[0]) {
            endButton[0].style.display = "block";
          }
          if (participantName && participantName[0]) {
            for (let participant of participantName) {
              participant.style.display = "block";
            }
          }
          if (mainContent && mainContent[0]) {
            mainContent[0].classList.remove("floating-main-content");
          }

          if (loader && loader[0]) {
            loader[0].classList.remove("loading-spinner");
          }

          if (meetingWindow) {
            meetingWindow.classList.remove("floating-video-meeting");
          }
          if (localVideo && localVideo[0]) {
            localVideo[0].style.display = "flex";
          }
          if (floatingPtz && floatingPtz[0]) {
            floatingPtz[0].style.display = "block";
          }
          if (zoomButtons && zoomButtons[0]) {
            zoomButtons[0].style.display = "block";
          }
        } else {
          if (endButton && endButton[0]) {
            endButton[0].style.display = "none";
          }
          this.hideVmaatuControls = true;
          if (participantName && participantName[0]) {
            for (let participant of participantName) {
              participant.style.display = "none";
            }
          }

          if (mainContent && mainContent[0]) {
            mainContent[0].classList.add("floating-main-content");
          }

          if (loader && loader[0]) {
            loader[0].classList.add("loading-spinner");
          }
          if (meetingWindow) {
            meetingWindow.classList.add("floating-video-meeting");
          }
          if (floatingPtz && floatingPtz[0]) {
            floatingPtz[0].style.display = "none";
          }
          if (zoomButtons && zoomButtons[0]) {
            zoomButtons[0].style.display = "none";
          }
        }
      }
    },
    askConfirmation() {
      //if role is doctor and prescription not shared and prescription mandatory then it should postponed
      if (
        this.IS_DOCTOR &&
        this.settings.mandatoryPrescription &&
        this.settings.mandatoryPrescription.enabled &&
        !this.PRESCRIPTION_SHARED
      ) {
        swal
          .fire({
            title: this.$t("message.Prescription not Shared"),
            text: this.$t(
              "message.Prescription is mandatory, would you like to postpone or prescribe now"
            ),
            confirmButtonText: this.$t("message.Postpone"),
            showCancelButton: true,
            cancelButtonText: this.$t("message.Prescribe"),
          })
          .then(async (result) => {
            if (result && result.value) {
              if (this.$refs["webex-teams"]) {
                this.endWebexCall();
              } else if (this.$refs.vmaatu) {
                this.$refs.vmaatu.destroy();
              }

              // when doctor postpones prescription, the currentAppointmentForPatient prescription gets postponed.

              // await this.$store.dispatch("updateStatus", {
              //   appointmentId: this.appointment._id,
              //   status: this.appointment.latestStatus,
              // });

              // updating status for current appointment for patient
              if (this.appointmentForCurrentPatient) {
                this.appointmentForCurrentPatient.latestStatus = "Postponed";
                await this.$store.dispatch("updateStatus", {
                  appointmentId: this.appointmentForCurrentPatient._id,
                  status: this.appointmentForCurrentPatient.latestStatus,
                });
              }

              socket.emit("appointmentPostponed", {
                appointmentId: this.appointment._id,
                endpointId: this.appointment.endpoint,
                user: this.user.roles[0],
                providerId: this.user._id,
              });

              this.$router.push("feedback");
            } else if (result && result.dismiss == "cancel") {
              let tabs = this.$refs.mainTab.tabs;
              let tab;
              tabs.forEach((element) => {
                if (element.$el.id == "prescription") {
                  tab = element;
                }
              });
              this.$refs.mainTab.activateTab(tab);
            }
          });
      } else {
        swal
          .fire({
            title: this.$t("message.Are you sure?"),
            text: !this.chatMode
              ? this.$t("message.You will not be able to join later")
              : "",
            confirmButtonText: this.$t("message.Exit"),
            showCancelButton: true,
            cancelButtonText: this.$t("message.Stay"),
          })
          .then(async (result) => {
            if (result && result.value) {
              if (this.$refs["webex-teams"]) {
                this.endWebexCall();
              } else if (this.$refs.vmaatu) {
                this.$refs.vmaatu.destroy();
              }

              let response = await this.$store.dispatch(
                "getAppointment",
                this.appointment._id
              );

              if (
                this.chatMode &&
                this.IS_NURSE &&
                response &&
                response._id &&
                response.latestStatus != "Postponed" &&
                response.latestStatus != "Completed" &&
                response.latestStatus != "Closed"
              ) {
                if (this.showVideo) {
                  if (this.$refs.vmaatu) {
                    this.$refs.vmaatu.destroy();
                  }
                  let res = await this.$store.dispatch("updateCallStatus", {
                    appointmentId: this.appointment._id,
                    status: "ended",
                    exitChat: true,
                  });

                  if (res && res._id) {
                    //Get appointment messages
                    if (this.appointment) {
                      let response = await this.$store.dispatch(
                        "getAppointmentMessages",
                        this.appointment._id
                      );
                      this.appointmentMessages = response;
                    }
                    let message = {
                      username: this.user.username,
                      status: "ended",
                      to: this.remoteUser.id,
                    };
                    socket.emit("newChatMessage", {
                      appointmentId: this.appointment._id,
                      chatMessage: message,
                    });
                  }
                }

                if (this.appointmentForCurrentPatient) {
                  this.endAppointmentForCurrentPatient();
                }

                socket.emit("leaveRoom", {
                  type: "appointment",
                  id: this.appointment._id,
                  userId: this.user._id,
                });
                this.$router.push("nursehome");
                return;
              }

              if (response && response._id) {
                //Update status only if doctor has not postponed the precription
                if (this.IS_DOCTOR || response.latestStatus != "Postponed") {
                  if (this.user.roles.indexOf("nurse") > -1) {
                    response.latestStatus = "Closed";
                  } else if (
                    this.IS_DOCTOR &&
                    this.user._id == response.provider.providerId
                  ) {
                    response.latestStatus = "Completed";
                    if (this.appointmentForCurrentPatient) {
                      localStorage.removeItem(
                        "prescription" + this.appointmentForCurrentPatient._id
                      );
                    }
                  }

                  await this.$store.commit("setState", {
                    stateName: "appointment",
                    stateValue: response,
                  });
                }
              }
              await this.$store.dispatch("updateStatus", {
                appointmentId: this.appointment._id,
                status: this.appointment.latestStatus,
              });
              let socketData = {
                appointmentId: this.appointment._id,
                endpointId: this.appointment.endpoint,
                user: this.user.roles[0],
                providerId: this.appointment.provider.providerId,
              };
              if (
                this.appointment &&
                this.appointment.patient &&
                this.appointment.patient.patientId
              ) {
                socketData["patientId"] = this.appointment.patient.patientId;
              }

              if (this.appointmentForCurrentPatient) {
                this.endAppointmentForCurrentPatient();
              }
              socket.emit("appointmentExit", socketData);

              // Receipt email
              if (
                this.appointment.consultationType == "telemed-direct" &&
                this.settings &&
                this.settings.directBookings &&
                this.settings.directBookings.GENERATE_RECEIPT
              ) {
                let loader = this.$loading.show();
                try {
                  this.appointment.provider.user = this.user;
                  await ReceiptService.getDataURL(
                    this.appointment,
                    async (dataUrl) => {
                      try {
                        await this.$store.dispatch("emailReceipt", {
                          to: this.appointment.patient.email,
                          appointmentReferenceId: this.appointment.referenceId,
                          providerFirstName:
                            this.appointment.provider.firstName,
                          providerLastName: this.appointment.provider.lastName,
                          appointmentDateTime: moment(
                            parseInt(this.appointment.scheduledTimestamp.start)
                          ).format("Do MMMM YYYY h:mm A"),
                          receipt: dataUrl,
                        });
                      } catch (e) {
                        console.log(e);
                      }
                    }
                  );
                } catch (e) {
                  console.log(e);
                }
                loader.hide();
              }

              this.$router.push("feedback");
            }
          });
      }
    },
    askConfirmationForCareco() {
      swal
        .fire({
          title: this.$t("message.Are you sure?"),
          confirmButtonText: this.$t("message.Exit"),
          showCancelButton: true,
          cancelButtonText: this.$t("message.Stay"),
        })
        .then(async (result) => {
          if (result && result.value) {
            if (this.showVideo) {
              if (this.$refs.vmaatu) {
                this.$refs.vmaatu.destroy();
              }
              let response = await this.$store.dispatch("updateCallStatus", {
                appointmentId: this.appointment._id,
                status: "ended",
                exitChat: true,
              });

              if (response && response._id) {
                //Get appointment messages
                if (this.appointment) {
                  let response = await this.$store.dispatch(
                    "getAppointmentMessages",
                    this.appointment._id
                  );
                  this.appointmentMessages = response;
                }

                let message = {
                  username: this.user.username,
                  status: "ended",
                  to: this.remoteUser.id,
                };
                socket.emit("newChatMessage", {
                  appointmentId: this.appointment._id,
                  chatMessage: message,
                });
              }
              let newMessage = {
                username: this.user.username,
                name: `${this.user.firstName} ${this.user.lastName}`,
                content: this.$t("message.Doctor's assistant exited the chat"),
                time: moment().format("DD-MM-YYYY, h:mm a"),
                type: "system",
                carecoExitedMessage: true,
              };
              await this.updateMessages(newMessage);
              socket.emit("leaveRoom", {
                type: "appointment",
                id: this.appointment._id,
                userId: this.user._id,
              });
              this.$router.push("carecohome");
            }
          }
        });
    },
    askConfirmationForPatient() {
      swal
        .fire({
          title: this.$t("message.Are you sure?"),
          confirmButtonText: this.$t("message.Exit"),
          showCancelButton: true,
          cancelButtonText: this.$t("message.Stay"),
        })
        .then(async (result) => {
          if (result && result.value) {
            if (this.$refs["webex-teams"]) {
              this.endWebexCall();
            } else if (this.$refs.vmaatu) {
              this.$refs.vmaatu.destroy();
            }
            this.$router.push("patienthome");
          }
        });
    },
    async exitChat() {
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
        backgroundColor: "white",
      });
      if (this.$refs["webex-teams"]) {
        this.endWebexCall();
      } else if (this.$refs.vmaatu) {
        this.$refs.vmaatu.destroy();
      }

      if (this.markCompleted) {
        if (this.showVideo) {
          if (this.$refs.vmaatu) {
            this.$refs.vmaatu.destroy();
          }
          await this.$store.dispatch("updateCallStatus", {
            appointmentId: this.appointment._id,
            status: "ended",
            exitChat: true,
          });

          //Get appointment messages
          if (this.appointment) {
            let response = await this.$store.dispatch(
              "getAppointmentMessages",
              this.appointment._id
            );
            this.appointmentMessages = response;
          }

          let message = {
            username: this.user.username,
            status: "ended",
            to: this.remoteUser.id,
          };
          socket.emit("newChatMessage", {
            appointmentId: this.appointment._id,
            chatMessage: message,
          });
        }

        let response = await this.$store.dispatch(
          "getAppointment",
          this.appointment._id
        );

        if (response && response._id) {
          //Update status only if doctor has not postponed the precription
          if (this.IS_DOCTOR || response.latestStatus != "Postponed") {
            if (this.user.roles.indexOf("nurse") > -1) {
              response.latestStatus = "Closed";
            } else if (
              this.IS_DOCTOR &&
              this.user._id == response.provider.providerId
            ) {
              response.latestStatus = "Completed";
              if (this.appointmentForCurrentPatient) {
                localStorage.removeItem("prescription" + this.appointment._id);
              }
            }

            await this.$store.commit("setState", {
              stateName: "appointment",
              stateValue: response,
            });
          }
        }
        console.log("latest status", this.appointment.latestStatus);
        await this.$store.dispatch("updateStatus", {
          appointmentId: this.appointment._id,
          status: this.appointment.latestStatus,
        });
        let socketData = {
          appointmentId: this.appointment._id,
          endpointId: this.appointment.endpoint,
          user: this.user.roles[0],
          providerId: this.user._id,
        };
        if (
          this.appointment &&
          this.appointment.patient &&
          this.appointment.patient.patientId
        ) {
          socketData["patientId"] = this.appointment.patient.patientId;
        }
        socket.emit("appointmentExit", socketData);

        // Receipt email
        if (
          this.appointment.consultationType == "telemed-direct" &&
          this.settings &&
          this.settings.directBookings &&
          this.settings.directBookings.GENERATE_RECEIPT
        ) {
          try {
            this.appointment.provider.user = this.user;
            await ReceiptService.getDataURL(
              this.appointment,
              async (dataUrl) => {
                try {
                  await this.$store.dispatch("emailReceipt", {
                    to: this.appointment.patient.email,
                    appointmentReferenceId: this.appointment.referenceId,
                    providerFirstName: this.appointment.provider.firstName,
                    providerLastName: this.appointment.provider.lastName,
                    appointmentDateTime: moment(
                      parseInt(this.appointment.scheduledTimestamp.start)
                    ).format("Do MMMM YYYY h:mm A"),
                    receipt: dataUrl,
                  });
                } catch (e) {
                  console.log(e);
                }
              }
            );
          } catch (e) {
            console.log(e);
          }
        }

        for (let associate of this.user.associations) {
          if (associate.associationType == "assistant") {
            socket.emit("appointmentListUpdate", {
              assistantId: associate.associatedUser,
            });
          }
        }
        loader.hide();
        this.$router.push("feedback");
      } else {
        if (this.showVideo) {
          if (this.$refs.vmaatu) {
            this.$refs.vmaatu.destroy();
          }
          let response = await this.$store.dispatch("updateCallStatus", {
            appointmentId: this.appointment._id,
            status: "ended",
            exitChat: true,
          });

          if (response && response._id) {
            //Get appointment messages
            if (this.appointment) {
              let response = await this.$store.dispatch(
                "getAppointmentMessages",
                this.appointment._id
              );
              this.appointmentMessages = response;
            }

            let message = {
              username: this.user.username,
              status: "ended",
              to: this.remoteUser.id,
            };
            socket.emit("newChatMessage", {
              appointmentId: this.appointment._id,
              chatMessage: message,
            });
          }
        }
        let newMessage = {
          username: this.appointment.provider.username,
          name: `${this.appointment.provider.firstName} ${this.appointment.provider.lastName}`,
          content: this.$t("message.Doctor exited the chat"),
          time: moment().format("DD-MM-YYYY, h:mm a"),
          type: "system",
          doctorExitedMessage: true,
        };
        await this.updateMessages(newMessage);
        socket.emit("leaveRoom", {
          type: "appointment",
          id: this.appointment._id,
          userId: this.user._id,
        });
        loader.hide();
        this.$router.push("home");
      }
    },
    goToVideoCall() {
      this.activeTab = "video-call";
    },
    goToChatMessage() {
      this.activeTab = "chat-message";
    },

    async endWebexCall() {
      try {
        await this.$refs[
          "webex-teams"
        ].simpleMeetingsWebex.webexManager.endCall();
        await this.$store.dispatch("deleteWebexRoom", this.appointment._id);
      } catch (err) {
        console.log("Error in ending webex call", err);
      }
    },

    //Files
    async browseFiles() {
      let file = await chooser.getFile("image/*");
      if (file) {
        this.uploadFile(file);
      }
    },
    async openCameraForFileUpload() {
      var _this = this;

      if (this.$refs.vmaatu) {
        this.$refs.vmaatu.destroy();
        this.$refs.vmaatu.simpleMeetingsVmaatu = null;
      }

      navigator.camera.getPicture(
        async function (base64Data) {
          //Fix me: Refreshing vmaatu after image capture as it would freeze the local stream
          if (_this.$refs.vmaatu) {
            _this.$refs.vmaatu.initSimplemeetings();
            _this.hideVmaatuControls = true;
          }

          var fileData = "data:image/png;base64," + base64Data;
          const { value: fileName } = await swal.fire({
            title: _this.$t("message.Enter file name"),
            input: "text",
            inputValue: "Untitled.png",
            showCancelButton: true,
            inputValidator: (value) => {
              return !value && "Please Enter filename!";
            },
          });
          if (fileName) {
            let fileBlob = _this.dataURItoBlob(fileData);
            let fileToSave = {
              name: fileName.endsWith(".png") ? fileName : fileName + ".png",
              data: fileBlob,
              type: "image/png",
              size: fileBlob.size,
            };
            _this.saveFile(fileToSave);
          }
        },
        function (err) {
          //Fix me: Refreshing vmaatu after image capture as it would freeze the local stream

          if (_this.$refs.vmaatu) {
            _this.$refs.vmaatu.initSimplemeetings();
            _this.hideVmaatuControls = true;
          }

          console.log("error opening camera");
        },
        {
          sourceType: Camera.PictureSourceType.CAMERA,
          destinationType: Camera.DestinationType.DATA_URL,
          mediaType: Camera.MediaType.PICTURE,
          // allowEdit: true,
          correctOrientation: false,
          encodingType: Camera.EncodingType.PNG,
          quality: 10,
          cameraDirection: Camera.Direction.BACK,
          targetWidth: 300,
          targetHeight: 400,
        }
      );
    },
    async getFiles($state) {
      //Get appointment files
      if (!$state) {
        this.files = [];
        this.filesPagination = {
          pageNumber: 1,
          totalPages: 0,
        };
      }
      var query = {
        appointmentId: this.appointmentForCurrentPatient._id,
        kind: "PatientMedicalFile",
      };

      let response = await this.$store.dispatch("getFiles", {
        query,
        pageNumber: this.filesPagination.pageNumber,
        pageSize: screen.height < 721 ? "7" : "11",
      });

      if (response.data && response.data.length) {
        this.files.push(...response.data);
        this.filesPagination.totalPages = response.totalPages;
        this.filesPagination.pageNumber += 1;
        $state && $state.loaded();
      } else {
        $state && $state.complete();
      }
    },
    async viewFile(file) {
      let that = this;
      try {
        that.loader = this.$loading.show({
          // Optional parameters
          container: null,
          canCancel: false,
        });
        //get file from server
        let fileArrayBuffer = await this.$store.dispatch(
          "getFile",
          file.fileId || file.url
        );
        let fileType = file.type;
        if (fileType == "prescription") {
          fileType = "application/pdf";
        }
        let pdfBlob = new Blob([fileArrayBuffer], { type: fileType });

        let storageLocation = "";

        if (typeof device !== "undefined") {
          switch (device.platform) {
            case "Android":
              //using cacheDirectory to clear the storage after preview
              storageLocation = cordova.file.cacheDirectory;
              break;

            case "iOS":
              storageLocation = cordova.file.documentsDirectory;
              break;
          }

          let folderPath = storageLocation;

          window.resolveLocalFileSystemURL(
            folderPath,
            function (dir) {
              dir.getFile(
                file.name,
                {
                  create: true,
                },
                function (file) {
                  file.createWriter(
                    function (fileWriter) {
                      fileWriter.write(pdfBlob);

                      fileWriter.onwriteend = function () {
                        var url = file.nativeURL;
                        cordova.plugins.fileOpener2.open(url, pdfBlob.type, {
                          error: function error(err) {
                            console.error(err);
                            that.loader.hide();
                            alert(this.$t("message.Unable to download"));
                          },
                          success: function success() {
                            that.loader.hide();
                            console.log("success with opening the file");
                          },
                        });
                      };

                      fileWriter.onerror = function (err) {
                        that.loader.hide();
                        alert(this.$t("message.Unable to download"));
                        console.error(err);
                      };
                    },
                    function (err) {
                      that.loader.hide();
                      // failed
                      alert(this.$t("message.Unable to download"));
                      console.error(err);
                    }
                  );
                },
                function (err) {
                  that.loader.hide();
                  alert(this.$t("message.Unable to download"));
                  console.error(err);
                }
              );
            },
            function (err) {
              that.loader.hide();
              alert(this.$t("message.Unable to download"));
              console.error(err);
            }
          );
        }
      } catch (e) {
        that.loader.hide();
        console.log(e);
      }
    },
    async uploadFile(file) {
      let that = this;
      let loader = that.$loading.show({
        container: null,
        canCancel: false,
      });

      try {
        let response = await that.$store.dispatch("uploadFileToMinio", file);

        var fileDetails = {
          name: file.name,
          type: file.mediaType,
          size: response.fileSize,
          fileId: response.fileId,
        };

        fileDetails.appointmentId = this.appointmentForCurrentPatient._id;
        fileDetails.patientId =
          this.appointmentForCurrentPatient.patient.patientId;

        //Save file details in mongo
        try {
          let savedFile = await this.$store.dispatch(
            "savePatientFile",
            fileDetails
          );

          //Send file in chat
          let msg = {
            username: this.user.username,
            name: `${this.user.firstName} ${this.user.lastName}`,
            firstName: this.user.firstName,
            lastName: this.user.lastName,
            content: savedFile.name,
            fileId: savedFile.fileId,
            text: "",
            time: moment().format("DD-MM-YYYY, h:mm a"),
            type: "file",
            fileType: savedFile.type,
          };
          this.updateMessages(msg);

          this.getFiles();
          loader.hide();
          swal.fire({
            title: that.$t("message.File Shared!"),
            type: "success",
            timer: 2000,
          });
          socket.emit("filesUpdate", {
            appointmentId: this.appointment._id,
            userId: this.user._id,
          });
        } catch (e) {
          loader.hide();
          console.log("Error updating file share status", e);
          swal.fire({
            title: that.$t("message.File couldn't be shared!"),
            type: "error",
            timer: 5000,
          });
        }
        return response;
      } catch (e) {
        console.log(e);
        loader.hide();
        swal.fire({
          type: "error",
          title: that.$t("message.File upload error"),
          text: that.$t("message.Could not update the file"),
          timer: 5000,
        });
      }
    },
    async saveFile(file) {
      //if file size is> 10MB, reject
      //1000000
      let _this = this;
      if (file.size / 1000000 > 10) {
        swal.fire({
          title: _this.$t("message.Ooops!"),
          text: _this.$t("message.Maximum file size allowed is 10MB!"),
          type: "error",
          timer: 5000,
        });
      } else {
        file.appointmentId = this.appointmentForCurrentPatient._id;
        file.patientId = this.appointmentForCurrentPatient.patient.patientId;
        let loader = this.$loading.show({
          // Optional parameters
          container: null,
          canCancel: false,
        });
        try {
          let _file = await _this.$store.dispatch("uploadFile", file);
          this.getFiles();

          loader.hide();

          //Send file in chat
          let msg = {
            username: this.user.username,
            name: `${this.user.firstName} ${this.user.lastName}`,
            firstName: this.user.firstName,
            lastName: this.user.lastName,
            content: _file.name,
            fileId: _file.fileId,
            text: "",
            time: moment().format("DD-MM-YYYY, h:mm a"),
            type: "file",
            fileType: _file.type,
          };
          this.updateMessages(msg);

          swal.fire({
            title: this.$t("message.File Shared!"),
            type: "success",
            timer: 3000,
          });
          socket.emit("filesUpdate", {
            appointmentId: this.appointment._id,
            userId: this.user._id,
          });
        } catch (err) {
          loader.hide();
          swal.fire({
            title: _this.$t("message.Ooops!"),
            text: _this.$t("message.Error while uploading file!"),
            type: "error",
            timer: 5000,
          });
        }
      }
    },

    getFormattedDate(date) {
      return moment(date).format("DD-MM-YYYY, hh:mm a");
    },
    async deleteFile(file, index) {
      let _this = this;
      swal
        .fire({
          title: _this.$t("message.Delete File?"),
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: _this.$t("message.Yes"),
          cancelButtonText: _this.$t("message.No"),
          closeOnConfirm: true,
        })
        .then(async (confirm) => {
          if (confirm.value) {
            _this.loader = _this.$loading.show({
              // Optional parameters
              container: null,
              canCancel: false,
            });
            try {
              await _this.$store.dispatch("deleteFile", file);
              //Commented this to fix last file not getting deleting from UI
              /*               if (
                this.files.length == 1 &&
                this.filesPagination.pageNumber != 1
              ) {
                this.filesPagination.pageNumber--;
              } else {
                this.getFiles();
              } */
              this.getFiles();
              _this.loader.hide();
              swal.fire({
                title: _this.$t("message.Success!"),
                text: _this.$t("message.File deleted successfully"),
                type: "success",
                timer: 3000,
              });
            } catch (err) {
              _this.loader.hide();
              swal.fire({
                title: _this.$t("message.Ooops!"),
                text: _this.$t("message.Error while deleting file"),
                type: "error",
                timer: 5000,
              });
            }
          } else {
            swal.close();
          }
        });
    },

    //Prescription
    previewPrescription() {
      let that = this;
      this.SHOW_PRESCRIPTION_PREVIEW = true;
    },
    closePrescriptionPreview() {
      this.SHOW_PRESCRIPTION_PREVIEW = false;
      $("#prescription-viewer-wrapper canvas").remove();
    },
    sharePrescription() {
      this.closePrescriptionPreview();
      if (
        this.prescription.prescriptions.imagingPrescription &&
        this.prescription.prescriptions.imagingPrescription.enabled === false &&
        (this.prescription.prescriptions.labPrescription === undefined ||
          this.prescription.prescriptions.labPrescription === "") &&
        (this.prescription.prescriptions.descriptiveNotes === undefined ||
          this.prescription.prescriptions.descriptiveNotes === "") &&
        this.prescription.prescriptions.provisionalDiagnosis.icdCodes.length ==
          0 &&
        (this.prescription.prescriptions.provisionalDiagnosis.notes ===
          undefined ||
          this.prescription.prescriptions.provisionalDiagnosis.notes === "") &&
        (this.prescription.prescriptions.soapNotes === undefined ||
          ((this.prescription.prescriptions.soapNotes.assessment === "" ||
            this.prescription.prescriptions.soapNotes.assessment ===
              undefined) &&
            (this.prescription.prescriptions.soapNotes.objective === "" ||
              this.prescription.prescriptions.soapNotes.objective ===
                undefined) &&
            (this.prescription.prescriptions.soapNotes.plan === undefined ||
              this.prescription.prescriptions.soapNotes.plan === "") &&
            (this.prescription.prescriptions.soapNotes.subjective === "" ||
              this.prescription.prescriptions.soapNotes.subjective ===
                undefined))) &&
        (this.prescription.prescriptions.rx.length === 0 ||
          (this.prescription.prescriptions.rx[0].instruction === "" &&
            this.prescription.prescriptions.rx[0].name === ""))
      ) {
        swal.fire({
          title: "Error",
          text: this.$t("message.Prescription fields are empty"),
          timer: 2000,
          type: "warning",
        });
      } else {
        if (this.user.signature && this.user.signature.image) {
          this.prescription.prescriptions.signature = this.user.signature.image;
        } else {
          this.prescription.prescriptions.signature = "";
        }

        this.prescription.prescriptions.sharedbydoctor = true;

        //Signing code
        if (
          !this.signed &&
          this.settings.signatureEnabled &&
          this.user.signature &&
          !this.user.signature.enabled
        )
          swal.fire({
            title: "Warning",
            text: this.$t(
              "message.Please sign the prescription before sharing!"
            ),
            imageUrl: "/modules/core/img/signing2.png",
            timer: 3000,
          });
        else if (
          this.user.signature &&
          this.user.signature.enabled &&
          this.user.signature.provider
        ) {
          //this.loadingMessage = ('Generating PDF for signature');
          $("#prescriptionLoader").fadeIn();
          //combine two images to one image for DS
          var canvas = document.createElement("canvas");
          var context = canvas.getContext("2d");
          var img1 = new Image();
          var img2 = new Image();

          img1.onload = function () {
            img2.src = this.user.signature.provider.defaultSignImage
              ? this.user.signature.provider.defaultSignImage
              : "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=";
          };
          img2.onload = function () {
            context.drawImage(img1, 0, 0, 200, 100);
            context.drawImage(img2, 150, 30, 70, 70);
            this.signatureImgForDS = canvas.toDataURL();
          };
          img1.src = "data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=";
          //combine two images END

          //swal.fire({title:('Generating PDF...'),timer:4000,type:'info',showConfirmButton:false});
          $("#prescriptionPopupIframe").prop("src", "");
          $("#prescriptionPopupIframe").prop(
            "src",
            "/modules/core/views/esign-popup.html"
          );
          //generate pdf and prompt pin if usbtoken
          Prescription.getDataURL(
            this.appointment,
            {},
            function (generatedPDF) {
              if (this.user.signature.provider.type == "usbtoken") {
                this.prescriptionPDF = generatedPDF;
                this.signatureDetails = {
                  alias: this.user.signature.alias,
                  driverPath:
                    this.user.signature.provider.driverpath[this.OSName],
                  certificateChain:
                    this.user.signature.provider.certificatechain,
                  signatureImg: this.signatureImgForDS,
                  initUrl:
                    this.user.signature.provider.tokenServiceUrls &&
                    this.user.signature.provider.tokenServiceUrls.init
                      ? this.user.signature.provider.tokenServiceUrls.init
                      : "",
                  testUrl:
                    this.user.signature.provider.tokenServiceUrls &&
                    this.user.signature.provider.tokenServiceUrls.test
                      ? this.user.signature.provider.tokenServiceUrls.test
                      : "",
                };
                this.promptPinAndSend(this.signatureDetails);
              } else if (this.user.signature.provider.type == "cloud") {
                $("#prescriptionLoader").fadeOut();
                $("#prescriptionPopup").modal();

                this.prescriptionPDF = generatedPDF.slice(28);

                $("#prescriptionPopupIframe")
                  .contents()
                  .find("#File")
                  .val(this.prescriptionPDF);
                $("#prescriptionPopupIframe")
                  .contents()
                  .find("#Name")
                  .val(this.user.firstName + " " + this.user.lastName);
                $("#prescriptionPopupIframe")
                  .contents()
                  .find("#FileType")
                  .val("PDF");
                $("#prescriptionPopupIframe")
                  .contents()
                  .find("#SelectPage")
                  .val(
                    this.user.signature.provider.pagesToSign
                      ? this.user.signature.provider.pagesToSign
                      : "ALL"
                  );
                $("#prescriptionPopupIframe")
                  .contents()
                  .find("#ReferenceNumber")
                  .val(this.appointmentId);
                $("#prescriptionPopupIframe")
                  .contents()
                  .find("#SignatureType")
                  .val("3");
                $("#prescriptionPopupIframe")
                  .contents()
                  .find("#SignaturePosition")
                  .val(
                    this.user.signature.provider.signaturePosition
                      ? this.user.signature.provider.signaturePosition
                      : "Bottom-Right"
                  );
                $("#prescriptionPopupIframe")
                  .contents()
                  .find("#AuthToken")
                  .val(this.user.signature.provider.accessToken);
                $("#prescriptionPopupIframe")
                  .contents()
                  .find("#PreviewRequired")
                  .val("True");
                $("#prescriptionPopupIframe")
                  .contents()
                  .find("#SUrl")
                  .val(location.origin + "/integrations/esign/success");
                $("#prescriptionPopupIframe")
                  .contents()
                  .find("#FUrl")
                  .val(location.origin + "/integrations/esign/failure");
                $("#prescriptionPopupIframe")
                  .contents()
                  .find("#CUrl")
                  .val(location.origin + "/integrations/esign/failure");

                $("#prescriptionPopupIframe")
                  .contents()
                  .find("#frmdata")
                  .prop("action", this.user.signature.provider.url);

                $("#prescriptionPopupIframe")
                  .contents()
                  .find("#frmdata")
                  .submit();
              }
            }
          );
        } else {
          this.updateApptOnSignatureShare();
        }
      }
    },
    postponePrescription() {
      swal
        .fire({
          title: this.$t("message.Postpone Prescription"),
          text: this.$t(
            "message.Appointment will be marked completed and prescription can still be shared"
          ),
          confirmButtonText: this.$t("message.Confirm"),
          showCancelButton: true,
          cancelButtonText: "Cancel",
        })
        .then(async (result) => {
          if (result && result.value) {
            if (this.appointmentForCurrentPatient) {
              this.appointmentForCurrentPatient.latestStatus = "Postponed";
              await this.$store.dispatch("updateStatus", {
                appointmentId: this.appointmentForCurrentPatient._id,
                status: this.appointmentForCurrentPatient.latestStatus,
              });

              this.appointmentForCurrentPatient = null;

              this.resetPatientDetailsForAppointment();

              await this.$store.dispatch(
                "removeAppointmentReferenceFromDiscussion",
                {
                  discussionId: this.appointment._id,
                }
              );
            }

            socket.emit("appointmentPostponed", {
              appointmentId: this.appointment._id,
              endpointId: this.appointment.endpoint,
              user: this.user.roles[0],
              providerId: this.user._id,
            });

            if (this.chatMode && this.showVideo) {
              await this.$store.dispatch("updateCallStatus", {
                appointmentId: this.appointment._id,
                status: "ended",
                exitChat: true,
              });

              let message = {
                username: this.user.username,
                status: "ended",
                to: this.remoteUser.id,
              };
              socket.emit("newChatMessage", {
                appointmentId: this.appointment._id,
                chatMessage: message,
              });
            }

            if (this.chatMode) {
              for (let associate of this.user.associations) {
                if (associate.associationType == "assistant") {
                  socket.emit("appointmentListUpdate", {
                    assistantId: associate.associatedUser,
                  });
                }
              }
            }
          }
        });
    },
    async updateApptOnSignatureShare() {
      let that = this;
      if (
        this.prescription.prescriptions.followup &&
        this.prescription.prescriptions.followup.requested
      ) {
        this.prescription.prescriptions.followup.date = moment(
          this.prescription.prescriptions.followup.date
        ).valueOf();
      }

      try {
        this.prescription = await this.$store.dispatch("sharePrescription", {
          prescription: this.prescription,
          appointmentId: this.appointmentForCurrentPatient._id,
        });
        localStorage.removeItem(
          "prescription" + this.appointmentForCurrentPatient._id
        );
      } catch (error) {
        if (error.response.data.errorCode == "PR001") {
          swal.fire({
            title: this.$t("message.Prescription not Shared"),
            text: this.$t("message.Nurse has insufficient credit balance"), // Nurse has insufficient credit balance
            timer: 2000,
            type: "warning",
          });
        } else {
          swal.fire({
            type: "error",
            title: this.$t("message.Prescription not Shared"),
            timer: 3000,
          });
        }
        return;
      }

      //Show Email popup for telemed express
      if (this.appointment.consultationType == "telemed-direct") {
        this.mailDetails = {
          to: this.appointment.patient.email,
          cc: this.appointment.provider.email,
          subject:
            this.$t("message.Summary & Prescriptions from Dr") +
            this.appointment.provider.firstName +
            " " +
            this.appointment.provider.lastName,
          MAIL_PRESCRIPTION: true,
          MAIL_ATTACHMENTS: false,
          CC_TO_ME: false,
        };
        this.SHOW_MAIL_POPUP = true;
      } else {
        this.proceedToSendPrescription();
      }
    },

    async proceedToSendPrescription() {
      this.SHOW_MAIL_POPUP = false;

      //Send prescription as email for telemed express
      if (this.appointment.consultationType == "telemed-direct") {
        if (this.chatMode) {
          await this.sendPrescription(true, true);
        } else {
          await this.sendPrescription(true, false);
        }
      } else {
        if (this.chatMode) {
          await this.sendPrescription(false, true);
        }
      }

      socket.emit("prescriptionsUpdate", {
        appointmentId: this.appointment._id,
        userId: this.user._id,
        prescriptionId: this.prescription._id,
      });

      var msg = this.$t("message.Prescription Shared");

      //Show 'Saved' message if it's a in-person appointment
      if (this.appointment.consultationType == "inperson")
        msg = "Prescription Saved";
      if (
        this.appointment.consultationType != "telemed-direct" &&
        !this.chatMode
      ) {
        swal.fire({
          title: msg,
          timer: 2000,
          type: "success",
        });
        this.PRESCRIPTION_SHARED = true;
      }
    },
    async sendPrescription(sendMail, sendChat) {
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
        backgroundColor: "white",
      });

      let prescriptionDate = null;
      if (this.prescription.created) {
        prescriptionDate = this.prescription.created;
      }

      PrescriptionService.getDataURL(
        this.appointment,
        this.prescription.prescriptions,
        prescriptionDate,
        {},
        async (dataUrl) => {
          try {
            let emailData = {
              to: this.mailDetails.to,
              subject: this.mailDetails.subject,
            };

            if (this.mailDetails.CC_TO_ME && this.mailDetails.cc) {
              emailData["cc"] = this.mailDetails.cc;
            }

            if (
              this.HAS_ATTACHMENTS &&
              this.HAS_PRESCRIPTION &&
              this.mailDetails.MAIL_ATTACHMENTS &&
              this.mailDetails.MAIL_PRESCRIPTION
            ) {
              //Send both prescription and attcahments
              emailData["prescription"] = dataUrl;
              emailData["attachments"] =
                this.prescription.prescriptions.attachments;
            } else if (
              this.HAS_PRESCRIPTION &&
              this.mailDetails.MAIL_PRESCRIPTION
            ) {
              //Send only prescription
              emailData["prescription"] = dataUrl;
            } else if (
              this.HAS_ATTACHMENTS &&
              this.mailDetails.MAIL_ATTACHMENTS
            ) {
              //Send only attachments
              emailData["attachments"] =
                this.prescription.prescriptions.attachments;
            }
            if (sendMail) {
              await this.$store.dispatch("emailPrescription", emailData);
            }
            //Clearing mailDetails
            this.mailDetails = {};
          } catch (e) {
            console.log(e);
          }

          if (sendChat) {
            let fileBlob = this.dataURItoBlob(dataUrl);
            let fileArrayBuffer = await fileBlob.arrayBuffer();

            let fileToSave = {
              name: "Prescription.pdf",
              data: fileArrayBuffer,
              type: "prescription",
              size: fileBlob.size,
              appointmentId: this.appointment._id,
              patientId: this.appointment.patient.patientId,
            };

            let res = await this.$store.dispatch("uploadFile", fileToSave);
            let systemMessage = {
              username: this.appointment.provider.username,
              name: `${this.appointment.provider.firstName} ${this.appointment.provider.lastName}`,
              content: "Doctor has shared a prescription.",
              time: moment().format("DD-MM-YYYY, h:mm a"),
              type: "system",
              prescriptionSharedMessage: true,
            };
            let prescriptionMessage = {
              username: this.appointment.provider.username,
              name: `${this.appointment.provider.firstName} ${this.appointment.provider.lastName}`,
              content: res.name,
              fileId: res.fileId,
              text: "",
              time: moment().format("DD-MM-YYYY, h:mm a"),
              type: "file",
              fileType: res.type,
            };
            await this.updateMessages(systemMessage);
            await this.updateMessages(prescriptionMessage);
          }
          loader.hide();
          swal.fire({
            title: this.$t("message.Prescription Shared"),
            timer: 2000,
            type: "success",
          });
          this.PRESCRIPTION_SHARED = true;
        }
      );
    },
    closeMailPopUp() {
      this.SHOW_MAIL_POPUP = false;
    },

    //Patient history
    getAgeYears(date) {
      var m = moment(date);
      var years = moment().diff(m, "years", false);
      return years + " " + this.$t("message.Years");
    },
    viewPrescription(prescription) {
      this.selectedPrescription = prescription;
    },

    viewSelectedLaborder(labOrder) {
      this.selectedLaborder = labOrder;
    },

    async getVitalHistory() {
      try {
        this.historicVitals = await this.$store.dispatch("getVitalHistory", {
          patientId: this.appointmentForCurrentPatient.patient.patientId,
          deviceProfile: this.deviceProfile,
          fromTime: moment().subtract(30, "days").unix() * 1000,
          toTime: moment().unix() * 1000,
        });
      } catch (e) {
        console.log(e);
      }
    },

    async makeAudioCall() {
      let that = this;
      swal
        .fire({
          title: that.$t("message.Phone call will be initiated"),
          type: "info",
          showCancelButton: true,
          cancelButtonText: that.$t("message.Cancel"),
        })
        .then(async (result) => {
          if (result && result.value) {
            let callDetails = {
              from: that.user.mobileNumber,
            };
            if (that.IS_DOCTOR) {
              if (that.appointment.consultationType == "telemed-direct") {
                callDetails.to = that.appointment.patient.mobileNumber;
              } else {
                if (that.appointmentEndpoint.endpointType == "nurse") {
                  try {
                    let nurse = await that.$store.dispatch(
                      "getUserByUsername",
                      that.appointment.attendant.username
                    );
                    callDetails.to = nurse.mobileNumber;
                  } catch (e) {
                    console.log(e);
                    swal.fire({
                      type: "error",
                      text: that.$t(
                        "message.Could not initiate the phone call!"
                      ),
                      timer: 5000,
                    });
                  }
                } else {
                  callDetails.to = that.appointment.patient.mobileNumber;
                }
              }
            }

            that.$store.dispatch("makeAudioCall", callDetails);
          }
        });
    },
    async downloadPrescription() {
      let appointment = await this.$store.dispatch(
        "getAppointmentById",
        this.appointmentForCurrentPatient._id
      );

      let prescriptionDate = null;
      if (this.prescription.created) {
        prescriptionDate = this.prescription.created;
      }

      if (window.cordova) {
        PrescriptionService.getDataURL(
          appointment,
          this.prescription.prescriptions,
          prescriptionDate,
          {},
          (dataUrl) => {
            // convert base64 to raw binary data held in a string
            // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
            var byteString = atob(dataUrl.split(",")[1]);

            // separate out the mime component
            var mimeString = dataUrl.split(",")[0].split(":")[1].split(";")[0];

            // write the bytes of the string to an ArrayBuffer
            var ab = new ArrayBuffer(byteString.length);

            // create a view into the buffer
            var ia = new Uint8Array(ab);

            // set the bytes of the buffer to the correct values
            for (var i = 0; i < byteString.length; i++) {
              ia[i] = byteString.charCodeAt(i);
            }

            // write the ArrayBuffer to a blob, and you're done
            var pdfBlob = new Blob([ab], { type: mimeString });

            let storageLocation = "";

            if (typeof device !== "undefined") {
              switch (device.platform) {
                case "Android":
                  storageLocation = cordova.file.externalDataDirectory;
                  break;

                case "iOS":
                  storageLocation = cordova.file.documentsDirectory;
                  break;
              }

              let folderPath = storageLocation;
              let loader = this.$loading.show();

              window.resolveLocalFileSystemURL(
                folderPath,
                function (dir) {
                  dir.getFile(
                    "prescription",
                    {
                      create: true,
                    },
                    function (file) {
                      file.createWriter(
                        function (fileWriter) {
                          fileWriter.write(pdfBlob);

                          fileWriter.onwriteend = function () {
                            var url = file.nativeURL;
                            cordova.plugins.fileOpener2.open(
                              url,
                              pdfBlob.type,
                              {
                                error: function error(err) {
                                  console.error(err);
                                  loader.hide();
                                  alert(this.$t("message.Unable to download"));
                                },
                                success: function success() {
                                  loader.hide();
                                  console.log("success with opening the file");
                                },
                              }
                            );
                          };

                          fileWriter.onerror = function (err) {
                            loader.hide();
                            alert(this.$t("message.Unable to download"));
                            console.error(err);
                          };
                        },
                        function (err) {
                          loader.hide();
                          // failed
                          alert(this.$t("message.Unable to download"));
                          console.error(err);
                        }
                      );
                    },
                    function (err) {
                      loader.hide();
                      alert(this.$t("message.Unable to download"));
                      console.error(err);
                    }
                  );
                },
                function (err) {
                  loader.hide();
                  alert(this.$t("message.Unable to download"));
                  console.error(err);
                }
              );
            }
          }
        );
      } else {
        PrescriptionService.download(
          appointment,
          this.prescription.prescriptions,
          prescriptionDate,
          {}
        );
      }
    },
    async shareVitals(deviceIdentifier) {
      try {
        let vitals = {};
        this.deviceProfile.forEach((device) => {
          if (device.identifier == deviceIdentifier) {
            device.vitals.forEach((vital) => {
              if (vital.value) {
                vitals[vital.identifier] = {
                  name: vital.displayName[this.$i18n.locale],
                  value: vital.value,
                  unit: vital.unit.primary,
                };
              }
            });

            if (device.vitalsGroup) {
              device.vitalsGroup.forEach((group) => {
                if (group.vitals) {
                  group.vitals.forEach((vital) => {
                    if (vital.value) {
                      vitals[vital.identifier] = {
                        name: vital.displayName[this.$i18n.locale],
                        value: vital.value,
                        unit: vital.unit.primary,
                      };
                    }
                  });
                }
              });
            }
          }
        });

        //Save only when object is not empty
        if (!$.isEmptyObject(vitals)) {
          let appointment = (
            await this.$store.dispatch("updateVitals", {
              appointmentId: this.appointmentForCurrentPatient._id,
              vitals: vitals,
            })
          ).data;
          this.appointmentForCurrentPatient.vitals = appointment.vitals;
          socket.emit("vitalsUpdate", {
            appointmentId: this.appointment._id,
            userId: this.user._id,
          });
          this.getVitalHistory();
          swal.fire({
            title:
              this.appointment.consultationType != "checkup" &&
              !(
                this.IS_APPOINTMENT_CREATED_BY_DOCTOR &&
                this.appointment.consultationType == "inperson"
              )
                ? this.$t("message.Shared!")
                : this.$t("message.Saved!"),
            type: "success",
            timer: 1000,
          });

          //Save vitals to ES
          let vital = vitals;
          this.vital = vital;

          //Generating vitals data object to save
          if (
            this.appointmentForCurrentPatient &&
            this.appointmentForCurrentPatient.patient &&
            this.appointmentForCurrentPatient.patient.patientId
          ) {
            this.vitalsData = [];
            for (var vitalName in this.vital) {
              if (Number(this.vital[vitalName].value)) {
                this.vitalsData.push({
                  patientId:
                    this.appointmentForCurrentPatient.patient.patientId,
                  value: Number(this.vital[vitalName].value),
                  name: vitalName,
                  unit: this.vital[vitalName].unit,
                  provider: "manual",
                });
              }
            }

            await this.$store.dispatch("saveVitalsData", this.vitalsData);
          }
        } else {
          swal.fire({
            title: this.$t("message.Cannot share vitals"),
            text: this.$t("message.Vitals are empty"),
            type: "info",
            timer: 2000,
          });
        }
      } catch (e) {
        console.log(e);
        swal.fire({
          title: this.$t("message.Couldn't Share!"),
          type: "error",
          timer: 5000,
        });
      }
    },
    async ptzExecute(action, direction) {
      let speed = this.appointmentEndpoint.cameraSetting.ptzSpeed || 1;

      if (action == "reset") {
        this.vmaatuPtz(action, direction, speed);
      } else if (direction == "Stop") {
        this.vmaatuPtz(action, direction, speed);
        clearTimeout(this.ptzTimer);
      } else {
        console.log("normal");
        this.vmaatuPtz(action, direction, speed);
        this.ptzTimer = setTimeout(() => {
          this.vmaatuPtz(action, direction, speed);
        }, 2000);
      }
    },
    vmaatuPtz(action, direction, speed) {
      if (
        this.appointmentEndpoint.videoConfEPType == "VMAATU_RTC" ||
        this.appointmentEndpoint.videoConfEPType == "VMAATU_RTC_EXTERNAL"
      ) {
        let data = {
          payload: {
            action: action.toLowerCase(),
            direction: direction.toLowerCase(),
            speed: speed,
          },
          camera: this.appointmentEndpoint.cameraSetting
            ? this.appointmentEndpoint.cameraSetting.camera
            : "",
          port: this.appointmentEndpoint.cameraSetting
            ? this.appointmentEndpoint.cameraSetting.vendorId
            : "",
          controlType: "ptz",
        };

        //emit to endpoint message
        socket.emit("vmaatuVideoControl", {
          endpoint: this.appointmentEndpoint.name,
          data: data,
        });
      } else {
        let data = {
          payload: {
            phone: {
              type: this.appointmentEndpoint.videoConfEPType
                .replace("_", "")
                .toLowerCase(),
              firmware:
                this.appointmentEndpoint.videoConfDetails.firmwareVersion,
              number: this.appointmentEndpoint.videoConfDetails.phoneNumber,
              ip: this.appointmentEndpoint.videoConfDetails.ip,
              callIp: this.appointmentEndpoint.videoConfDetails.callIp,
              username: this.appointmentEndpoint.videoConfDetails.username,
              password: this.appointmentEndpoint.videoConfDetails.password,
              protocol:
                this.appointmentEndpoint.videoConfDetails.protocol.toLowerCase(),
              apiMode:
                this.appointmentEndpoint.videoConfDetails.apiMode.toLowerCase(),
            },
            action: action.toLowerCase(),
            direction: direction.toLowerCase(),
            speed: speed,
          },
          port:
            this.appointmentEndpoint.videoConfDetails.mode == "serial"
              ? this.appointmentEndpoint.videoConfDetails.comPort
              : "",
          controlType: "ptz",
          controlMode:
            this.appointmentEndpoint.videoConfDetails.mode == "clientHttp"
              ? "http"
              : this.appointmentEndpoint.videoConfDetails.mode,
        };

        //emit to endpoint message
        socket.emit("ciscoVideoControl", {
          endpoint: this.appointmentEndpoint.name,
          data: data,
        });
      }
    },
  },

  watch: {
    activeTab: function (value) {
      if (window && window.screen && window.screen.orientation) {
        //Disabling landscape mode for chat tab
        if (value == "chat-message") {
          window.screen.orientation.lock("portrait");
        } else {
          window.screen.orientation.unlock();
        }
      }
    },
    prescription: {
      handler(val) {
        localStorage.setItem(
          "prescription" + this.appointmentForCurrentPatient._id,
          JSON.stringify(val)
        );
      },
      deep: true,
    },
    ageUnit: function () {
      this.calculateDob();
    },
    patientAge: function () {
      this.calculateDob();
    },
  },
  // create event handler when device is rotated.
  created() {
    window.addEventListener("resize", this.resizeWindowEventHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeWindowEventHandler);
  },
};
</script>

<style scoped>
.start-video-text {
  position: absolute;
  top: 26.5em;
  inset-inline-end: 50%;
  transform: translateX(50%);
}

[dir="rtl"] .start-video-text {
  transform: translateX(-50%);
}

.autocomplete-result {
  margin-top: 1em;
  margin-bottom: 1em;
}

/deep/ #age-dropdown input {
  height: 40px;
  border-start-start-radius: 0;
  border-end-start-radius: 0;
  border-style: none;
  border-inline-start-style: solid;
  background-color: transparent !important;
  color: #9a9a9a;
}

/deep/.make-video-call-button {
  position: absolute;
  top: 20em;
  inset-inline-end: 50%;
  transform: translateX(50%);
}

[dir="rtl"] .make-video-call-button {
  transform: translateX(-50%);
}

.file-share-buttons {
  position: absolute;
  inset-inline-end: 50%;
  top: auto;
  z-index: 200;
  width: 18em;
  transform: translateX(50%);
}

[dir="rtl"] .file-share-buttons {
  transform: translateX(-50%);
}

/deep/.nav-pills-neutral .nav-link:first-child > div {
  max-width: 30px;
}

/* .video-audio-buttons > button {
  margin-right: 0.5em;
} */

.appointment-contron-buttons {
  z-index: 1031;
  position: fixed;
  top: 0px;
  inset-inline-end: 0px;
  display: flex;
  align-items: center;
  height: 56px;
}

.close-button {
  margin-right: 0.5em;
  padding: 7px;
  font-size: 1.5em;
  color: white;
}

/* Fix for prescription alert badge */
/* removed position relative interfering with navbar and was not needed  */
/deep/.card-header-nav {
  /* position: relative; */
}

/deep/.tab-content {
  /* remover because change made in parent */
  height: 100%;
  /* for fixed quick acction buttons from bottom */
  position: relative;
}

.content > div {
  height: 100%;
}

.tab-pane.active {
  height: 100%;
  overflow: scroll;
}

/deep/.patient-history-tabs {
  height: 100%;
}

/deep/.patient-history-tabs .tab-content {
  height: calc(100% - 30px);
}

/deep/.patient-history-tabs .tab-space {
  padding: 0px;
  padding-top: 2em;
}

#chat-message > div {
  height: 100%;
}

.ios #chat-message > div {
  height: 98%;
}

/deep/ .sc-chat-window {
  position: unset !important;
  padding-top: 2em !important;
  height: 100%;
  width: 100%;
  max-height: 100%;
}

/deep/ .sc-message--file {
  max-width: 35vh;
}

/deep/ .sc-message-list {
  height: 95% !important;
  background-image: url("../../assets/img/background.png") !important;
  background-color: #212529 !important;
  padding-top: 0em !important;
  padding-bottom: 0em !important;
}

@media (max-width: 450px) {
  /deep/ .sc-message {
    width: 100% !important;
  }
}

/deep/ .sc-message:first-of-type {
  margin-top: 4em !important;
}

/deep/ .sc-user-input--button svg {
  height: 25px !important;
  width: 25px !important;
}

/deep/ .full-name {
  font-weight: 600;
  color: var(--color-primary);
}

/deep/.sc-message--file .full-name {
  margin-top: -0.7em;
  margin-bottom: 0.4em;
}

/deep/ .sent .full-name {
  display: none;
}

/deep/ .confirmationModal .modal-dialog {
  margin-top: 70%;
}

.ios .appointment-contron-buttons {
  top: 2.2em;
}

/deep/.content-container {
  height: 100% !important;
}

.fullscreen-window {
  width: 100%;
  top: 7vh;
  bottom: 0px;
  inset-inline-end: 0px;
  height: 100%;
  background-color: #f1f1f1;
}

.draggable-window {
  height: 9.5em;
  width: 14em;
  background-color: rgb(241, 241, 241);
}

/deep/.draggable-window #remoteHolder {
  min-height: 0;
}

/deep/.draggable-window #remoteHolder.grid #remote-controls-buttons {
  left: 0;
}

.non-draggable-content {
  position: sticky !important;
  height: 100%;
  top: 0 !important;
}

.draggable-content {
  box-shadow: black 0px 1px 15px 1px;
  overflow: hidden;
  border-radius: 5px;
}

/deep/ .video-call-tab {
  display: block !important;
  width: 0px;
}

/deep/ .nav-pills .nav-item .nav-link {
  min-width: 60px;
}

/deep/ .patient-history-tabs a.nav-link {
  font-size: 13px;
}

@media screen and (max-width: 412px) {
  /deep/.nav-pills .nav-item .nav-link {
    min-width: 55px !important;
  }
}

.end-button {
  position: absolute;
  bottom: 5.5em;
  inset-inline-end: 50%;
  transform: translateX(50%);
  z-index: 2022;
}

/deep/ .file-container {
  border-top-left-radius: 0px;
}

#preview-pdf {
  font-size: 7em;
  margin-top: 7%;
  text-align: center;
  width: 100%;
}

#preview-img {
  max-width: 100%;
  height: 15em;
  margin-top: 1em;
}

#preview-video {
  max-width: 100%;
  height: 15em;
  margin-top: 1em;
}

.prescription-list {
  padding-bottom: 0.5em;
  padding-top: 0.5em;
  border-top: 1px solid #d6d0d0;
}

.prescription-list:first-child {
  border-top: none;
}

.prescription-list.selected {
  background-color: whitesmoke;
}

.prescription-icon {
  line-height: 3em;
  color: #2ca8ff;
  font-size: 1.5em;
}

.reason {
  font-size: 1.3em;
  margin-bottom: 2px;
}

/* /deep/.sc-message--file {
  max-width: 50%;
}
 */
/deep/ .fa-stack-1x,
.fa-stack-2x {
  text-align: inherit;
}

/deep/ .modal-content .modal-body {
  padding-left: 0px;
  padding-right: 0px;
}

/deep/ #prescription-viewer-wrapper canvas {
  border-bottom: 1px solid #00000075;
}

/deep/ .sc-message--system {
  opacity: 0.9 !important;
  color: #0d2747 !important;
  background-color: #f5f5f5 !important;
}

/deep/ .sc-message--system p {
  color: rgb(34, 34, 34) !important;
}

/deep/ label {
  margin-bottom: 0;
}

/deep/ .sc-message--content.received .sc-message--file i {
  color: rgb(134, 134, 134);
}

/deep/ .sc-image {
  max-height: 18em;
  max-width: 100%;
  min-width: 100%;
}

/deep/ .sc-video {
  max-width: 100%;
}

/deep/ .bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off {
  padding-left: 2.5em !important;
}

/deep/ .sc-user-input {
  background: #e6e6e6 !important;
  border-radius: 0px !important;
}

/deep/ .sc-user-input--text {
  color: rgb(86, 88, 103) !important;
  background-color: white !important;
  border-radius: 60px !important;
  margin-top: 0.5em !important;
  margin-bottom: 0.5em !important;
  padding-top: 0.5em !important;
  padding-bottom: 0.5em !important;
  line-height: 2 !important;
}

.chat-ended {
  position: absolute;
  bottom: 0px;
  display: flex;
  align-items: end;
  justify-content: center;
}

/deep/ .disable-input .sc-user-input {
  display: none !important;
}

.show-ripple .ripple {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 4em;
  width: 4em;
  border-radius: 100%;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.25);
  z-index: 1;
  inset-inline-end: 1.1em;
  top: 0.2em;
}

.show-ripple .ripple span {
  position: relative;
  font-size: 72px;
  height: 100%;
  width: 100%;
}

.show-ripple .ripple::after {
  opacity: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0px;
  left: 0px;
  inset-inline-end: 0;
  bottom: 0;
  content: "";
  height: 100%;
  width: 100%;
  border: 8px solid rgba(0, 0, 0, 0.2);
  border-radius: 100%;
  animation-name: ripple;
  animation-duration: 3s;
  animation-delay: 0s;
  animation-iteration-count: infinite;
  animation-timing-function: cubic-bezier(0.65, 0, 0.34, 1);
  z-index: -1;
}

.show-ripple .ripple::before {
  opacity: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0px;
  left: 0px;
  inset-inline-end: 0;
  bottom: 0;
  content: "";
  height: 100%;
  width: 100%;
  border: 8px solid rgba(0, 0, 0, 0.2);
  border-radius: 100%;
  animation-name: ripple;
  animation-duration: 3s;
  animation-delay: 0.5s;
  animation-iteration-count: infinite;
  animation-timing-function: cubic-bezier(0.65, 0, 0.34, 1);
  z-index: -1;
}

@keyframes ripple {
  from {
    opacity: 1;
    transform: scale3d(0.75, 0.75, 1);
  }

  to {
    opacity: 0;
    transform: scale3d(1.5, 1.5, 1);
  }
}

/deep/ .draggable-content {
  border-radius: 18px;
}

/deep/ .floating-video-meeting {
  height: 100% !important;
  margin: 0px !important;
}

/deep/ .floating-main-content {
  padding: 0px !important;
}

/deep/ .loading-spinner {
  top: unset !important;
  margin-top: unset !important;
  width: 100% !important;
  text-align: center !important;
  position: absolute !important;
}

/*PTZ control buttons*/
/* The Circle menu */
.circleMenu,
.circleMenu .inner,
.circleMenu .inner > li {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.mainBtn {
  display: block;
  width: 48px;
  height: 48px;
  position: relative;
  z-index: 20;
  background-color: #ffffff;
  -webkit-transition: -webkit-transform 0.3s ease;
  transition: -webkit-transform 0.3s ease;
  transition: transform 0.3s ease;
  transition: transform 0.3s ease, -webkit-transform 0.3s ease;
  border-radius: 100%;
}

.mainBtn:hover {
  cursor: pointer;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}

.mainBtn:focus {
  outline: 0 !important;
}

.circleMenu .inner,
.circleMenu .inner > li .inner {
  display: block;
  width: 150px;
  height: 150px;
  background-color: rgba(96, 125, 139, 0.35);
  padding: 6px;
  -webkit-transition: width 0.3s ease, height 0.3s ease;
  transition: width 0.3s ease, height 0.3s ease;
  border-radius: 100%;
}

/*.circleMenu:hover .inner, .circleMenu .inner:hover .inner, .circleMenu .inner > li:hover .inner {
  width: 150px;
  height: 150px;
}*/

.circleMenu .inner > li,
.circleMenu .inner .inner > li,
.circleMenu .inner > li .inner > li {
  z-index: 10;
  -webkit-transition: left 0.3s ease, top 0.3s ease;
  transition: left 0.3s ease, top 0.3s ease;
}

.circleMenu .inner > li:nth-child(1),
.circleMenu .inner:hover .inner > li:nth-child(1),
.circleMenu .inner > li:hover .inner > li:nth-child(1) {
  left: 20%;
}

.circleMenu .inner > li:nth-child(2),
.circleMenu .inner:hover .inner > li:nth-child(2),
.circleMenu .inner > li:hover .inner > li:nth-child(2) {
  top: 20%;
}

.circleMenu .inner > li:nth-child(3),
.circleMenu .inner:hover .inner > li:nth-child(3),
.circleMenu .inner > li:hover .inner > li:nth-child(3) {
  left: 80%;
}

.circleMenu .inner > li:nth-child(4),
.circleMenu .inner:hover .inner > li:nth-child(4),
.circleMenu .inner > li:hover .inner > li:nth-child(4) {
  top: 80%;
}

.circleMenu .fa,
.circleMenu .inner > li {
  color: #ffffff;
}

/* Other stuff */

.floating-ptz .outer,
.floating-ptz .inner,
.cart-controls .outer,
.cart-controls .inner {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.circleMenu .inner > li .fa:hover {
  color: #2196f3;
  cursor: pointer;
}

.floating-ptz,
.cart-controls {
  position: absolute;
  inset-inline-end: 75%;
  top: 60%;
  transform: translate(-50%, -50%);
  z-index: 1031;
}

.zoom-buttons {
  position: absolute;
  inset-inline-end: 0px;
  top: 60%;
  transform: translate(-50%, -50%);
  z-index: 1031;
  list-style-type: none;
}

.zoom-buttons > li:nth-child(1) {
  margin-bottom: 20%;
}

.zoom-buttons > li:nth-child(2) {
  margin-bottom: 20%;
}

.zoom-buttons > li:hover {
  cursor: pointer;
}

.zoom-buttons .fa-stack {
  color: rgba(96, 125, 139, 0.35);
}

/deep/.float-input-label {
  position: absolute;
  font-size: 0.65em;
  padding-left: 2em;
  color: var(--color-primary);
  top: 0.2em;
}

/deep/.float-input-label.age {
  top: 0.9em;
}
</style>


<style>
.ios .telemed .tab-content {
  height: calc(100% - 69px);
}
</style>
